import { useEffect, useState, ChangeEvent, Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// import { useMediaQuery } from '@mui/material';
import {
  Card,
  HeaderStyle,
  Tag,
  TagStyle,
  Theme,
  ButtonStyles,
  ButtonSize,
  Modal,
  Checkbox,
  TextAlign,
  Button,
  ButtonTypes,
  InputTypes,
  MLPVersion,
  Input,
  TextArea,
  useBreakpoint,
  ImageSlider,
  Tooltip,
  TooltipPreference,
  DatePicker,
  ButtonWidth,
  IconStyle,
  FAIcon,
  //ButtonIconPosition,
  Drawer,
  ImageEditorSize,
} from '../../ui/components';
import ImageEditor from '../../ui/components/ImageEditor/ImageEditor';
import {
  dateTimeToCustomFormat,
  formatDateDMYYYY,
  LoggerService,
  PAGES,
  trackPage,
  decryptString,
  processBeforeAfterImagesData,
  processBeforeAfterImagesResponse,
  encryptString,
} from '../../ui/utils';
import { useAdminToast } from '../../ui/components/AdminToast/AdminToast';
import DetailCardProgress from '../../ui/components/DetailCardProgress/DetailCardProgress';
import OperationCenterErrorCard, {
  ErrorType,
} from '../../ui/components/OperationCenterErrorCard/OperationCenterErrorCard';
import { getRoundedNumber } from '../../ui/utils/common';
import type { DynamicObjectInterface, AttachmentImageBA } from '../../sdk/type';
import CoachService from '../../sdk/services/coachService';
import ParticipantService from '../../sdk/services/participantService';
import LeaderService from '../../sdk/services/leaderService';
import TeamService from '../../sdk/services/teamService';
// import AcknowledgementService from '../../sdk/services/acknowlegementService';
import CampaignService from '../../sdk/services/campaignService';
import { useAPICall } from '../../hooks';
// import Error from '../../assets/image/icons/ico_error.svg';
import WarningIcon from '../../assets/image/icons/warning.svg';
import PhotoUnavailable from '../../assets/image/sample/photoUnavailable.png';
import CampaignLogo from '../../assets/image/Campaign_Logo.png';
import ChangeButton from '../../assets/image/icons/change_button.svg';
import RemoveButton from '../../assets/image/icons/remove_button.svg';
import LayerSquarePlus from '../../assets/image/icons/layer_square_plus.svg';
import healthGoalService from '../../sdk/services/healthGoalService';
import { customEventPropType } from '../../ui/components/ImageEditor/types/propsType';
import AttachmentService from '../../sdk/services/attachmentService';
import { CampaignConfigDataOrder } from '../admin/teams/edit/add-participant/[teamId]';
import { InputValidations } from '../../ui/components/Form/SearchComponent/types/propTypes';
import TableWithAction from '../../ui/components/TableWithAction/TableWithAction';
// import style from '../admin/teams/index.module.scss';
import Menu, { MenuItem } from '../../ui/components/Menu/Menu';
import { ContentItem } from '../terms/Terms';
import { getContent } from '../../sdk/services/contentService';
import intermediateMeasurementService from '../../sdk/services/intermediateMeasurementService';
import { UserData, DashboardProps, ActivityTypeOrder } from './dashboardConfig';
import { ParticipantData } from './team-list/team-profile';
import styles from './Dashboard.module.scss';

export interface ProgressType {
  weighingDate: Date;
  weight: number;
  bodyFat: number;
  muscleKilogram: number;
  checked: boolean;
}

export interface CampaignQuestionType {
  questionRecId: number;
  questionText: string;
  questionType: string;
  options: null;
}

export interface UserAnswerDataType {
  answerId: number;
  questionType: string;
  answerText: string;
  options: DynamicObjectInterface[] | null;
}

export const Dashboard = (props: DashboardProps) => {
  const { index, campaignData, decodedData } = props;
  const { t } = useTranslation();
  const [data, setData] = useState<UserData | null>(null);
  const [participantData, setParticipantData] = useState<ParticipantData>();
  const [formData, setFormData] = useState<UserData | null>(JSON.parse(JSON.stringify(data)) as UserData);
  const [alpValue, setAlpValue] = useState<{ input: string; check: boolean }>({ input: '', check: false });
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showCoachList, setShowCoachList] = useState(false);
  // const [masterList, setMasterList] = useState<{
  //   coachList: DynamicObjectInterface;
  // }>();
  //const [filteredCoachList, setFilteredCoachList] = useState(masterList?.coachList);
  // const [showAcknowledgment, setShowAcknowledgment] = useState(false);
  // const [isWeightInAcknowledged, setIsWeightInAcknowledged] = useState(false);
  // const [isWeightOutAcknowledged, setIsWeightOutAcknowledged] = useState(false);
  // const [confirmCheck, setConfirmCheck] = useState(true);
  const [coachName, setCoachName] = useState<string>('');
  const [coachInvalid, setCoachInvalid] = useState(false);
  const [isParticipant, setIsParticipant] = useState(false);
  const [campaignDetail, setCampaignDetail] = useState<CampaignConfigDataOrder>();
  const [isCoach, setIsCoach] = useState(false);
  const [isLeader, setIsLeader] = useState(false);
  const [images, setImages] = useState<Record<string, AttachmentImageBA>>({
    before_front: { photoId: 0, url: '', file: null },
    after_front: { photoId: 0, url: '', file: null },
    before_side: { photoId: 0, url: '', file: null },
    after_side: { photoId: 0, url: '', file: null },
  });
  const [profileImageUrls, setProfileImageUrls] = useState<Record<string, string | undefined>>({});
  const [isOpen, setIsOpen] = useState(false);
  const [isIndividual, setIsIndividual] = useState(false);
  const [carouselType, setCarouselType] = useState('');
  const [isImageUploaded, setIsImageUploaded] = useState(false);
  const apiCall = useAPICall();
  const { adminToast } = useAdminToast();
  const location = useLocation();
  const viewPortType = useBreakpoint();
  const isDesktopView = ['xs', 'sm'].indexOf(viewPortType) === -1;
  // const ipadDimensions = useMediaQuery('(max-width:960px) and (min-width:768px)');

  const fetchData = async () => {
    let isParticipant = campaignData[index].enrollment?.some(enrollment => enrollment.enrollmentType === 'PARTICIPANT');
    let isCoach = campaignData[index].enrollment?.some(enrollment => enrollment.enrollmentType === 'COACH');
    let isLeader = campaignData[index].enrollment?.some(enrollment => enrollment.enrollmentType === 'LEADER');

    let _data: UserData | null = null;

    const individualTeam = campaignData[index].enrollment.find(
      enrollment => enrollment.enrollmentType === 'PARTICIPANT',
    )?.isIndividualTeam;
    setIsIndividual(individualTeam === 1 ? true : false);

    if (isParticipant) {
      const resParticipant = await apiCall(
        ParticipantService.getParticipantDetail,
        {
          campaignId: campaignData[index].campaignId,
          teamId: campaignData[index].enrollment.find(enrollment => enrollment.enrollmentType === 'PARTICIPANT')
            ?.teamId,
          userId: decodedData.userId,
        },
        decodedData.userId,
      );

      if (resParticipant.data.data) {
        let _data: ParticipantData = resParticipant.data.data;
        _data.hideProfileImg = true;
        _data.showFiveProgress = true;
        _data.weightIn.weightInDate = _data.weightIn.weightedDate;
        _data.weightOut.weightOutDate = _data.weightOut.weightedDate;
        if (isCoach) {
          _data.points = {
            product: (_data.point.purchase ?? 0) + (_data.point.purchaseAdj ?? 0),
            result: (_data.point.winning ?? 0) + (_data.point.winningAdj ?? 0),
            subscribe: (_data.point.subscribe ?? 0) + (_data.point.subscribeAdj ?? 0),
          };
        }
        _data = {
          ..._data,
          weightIn: {
            ..._data.weightIn,
            bodyFat: _data?.weightIn?.bodyFat
              ? getRoundedNumber(parseFloat(decryptString(`${_data?.weightIn?.bodyFat}`)))
              : 0,
            height: _data?.weightIn?.height
              ? getRoundedNumber(parseFloat(decryptString(`${_data?.weightIn?.height}`)))
              : 0,
            muscleKilogram: _data?.weightIn?.muscleKilogram
              ? getRoundedNumber(parseFloat(decryptString(`${_data?.weightIn?.muscleKilogram}`)))
              : 0,
            musclePercentage: _data?.weightIn?.musclePercentage
              ? getRoundedNumber(parseFloat(decryptString(`${_data?.weightIn?.musclePercentage}`)))
              : 0,
            weight: _data?.weightIn?.weight
              ? getRoundedNumber(parseFloat(decryptString(`${_data?.weightIn?.weight}`)))
              : 0,
          },
          weightOut: {
            ..._data.weightOut,
            bodyFat: _data?.weightOut?.bodyFat
              ? getRoundedNumber(parseFloat(decryptString(`${_data?.weightOut?.bodyFat}`)))
              : null,
            height: _data?.weightOut?.height
              ? getRoundedNumber(parseFloat(decryptString(`${_data?.weightOut?.height}`)))
              : null,
            muscleKilogram: _data?.weightOut?.muscleKilogram
              ? getRoundedNumber(parseFloat(decryptString(`${_data?.weightOut?.muscleKilogram}`)))
              : null,
            musclePercentage: _data?.weightOut?.musclePercentage
              ? getRoundedNumber(parseFloat(decryptString(`${_data?.weightOut?.musclePercentage}`)))
              : null,
            weight: _data?.weightOut?.weight
              ? getRoundedNumber(parseFloat(decryptString(`${_data?.weightOut?.weight}`)))
              : null,
          },
        };
        setParticipantData(_data);
      }

      let res = await apiCall(
        ParticipantService.getParticipantDetail,
        {
          campaignId: campaignData[index].campaignId,
          teamId: campaignData[index].enrollment.find(enrollment => enrollment.enrollmentType === 'PARTICIPANT')
            ?.teamId,
        },
        decodedData.userId,
      );
      let teamData = await apiCall(ParticipantService.getTeamParticipants, {
        campaignId: campaignData[index].campaignId,
        teamId: campaignData[index].enrollment.find(enrollment => enrollment.enrollmentType === 'PARTICIPANT')?.teamId,
      });
      const rawData = res?.data?.data;
      const modifiedData: DynamicObjectInterface = {
        ...rawData,
        weightIn: {
          ...rawData?.weightIn,
          bodyFat: rawData?.weightIn?.bodyFat
            ? getRoundedNumber(parseFloat(decryptString(rawData?.weightIn?.bodyFat)))
            : 0,
          height: rawData?.weightIn?.height
            ? getRoundedNumber(parseFloat(decryptString(rawData?.weightIn?.height)))
            : 0,
          muscleKilogram: rawData?.weightIn?.muscleKilogram
            ? getRoundedNumber(parseFloat(decryptString(rawData?.weightIn?.muscleKilogram)))
            : 0,
          musclePercentage: rawData?.weightIn?.musclePercentage
            ? getRoundedNumber(parseFloat(decryptString(rawData?.weightIn?.musclePercentage)))
            : 0,
          weight: rawData?.weightIn?.weight
            ? getRoundedNumber(parseFloat(decryptString(rawData?.weightIn?.weight)))
            : 0,
        },
        weightOut: {
          ...rawData?.weightOut,
          bodyFat: rawData?.weightOut?.bodyFat
            ? getRoundedNumber(parseFloat(decryptString(rawData?.weightOut?.bodyFat)))
            : null,
          height: rawData?.weightOut?.height
            ? getRoundedNumber(parseFloat(decryptString(rawData?.weightOut?.height)))
            : null,
          muscleKilogram: rawData?.weightOut?.muscleKilogram
            ? getRoundedNumber(parseFloat(decryptString(rawData?.weightOut?.muscleKilogram)))
            : null,
          musclePercentage: rawData?.weightOut?.musclePercentage
            ? getRoundedNumber(parseFloat(decryptString(rawData?.weightOut?.musclePercentage)))
            : null,
          weight: rawData?.weightOut?.weight
            ? getRoundedNumber(parseFloat(decryptString(rawData?.weightOut?.weight)))
            : null,
        },
      };

      _data = { ...modifiedData };
      if (_data) {
        _data.activities = [];
        if (modifiedData?.rewards?.filter((i: DynamicObjectInterface) => i.rewardStatus === 'ACTIVE').length > 0) {
          _data.activities.push({
            activityName: modifiedData?.rewards?.[0]?.activityName,
            reward: modifiedData?.rewards?.filter((i: DynamicObjectInterface) => i.rewardStatus === 'ACTIVE'),
            type: 'PARTICIPANT',
          });
        }
        _data.campaignName = modifiedData?.campaign?.campaignName;
        _data.teamLeaderLoginId = modifiedData?.team?.teamLeaderUserId;
        _data.teamStartDate = teamData?.data?.data?.[0]?.teamDetail?.teamStartDate;
        _data.teamEndDate = teamData?.data?.data?.[0]?.teamDetail?.teamEndDate;
        _data.participantDetails = teamData?.data?.data;
        _data.teamName = teamData?.data?.data?.[0]?.teamDetail?.teamName;
        _data.teamId = campaignData[index].enrollment.find(
          enrollment => enrollment.enrollmentType === 'PARTICIPANT',
        )?.teamId;
        //team coach
        _data.teamCoachId = teamData?.data?.data?.[0]?.teamDetail?.coachId;
        _data.teamCoachName = teamData?.data?.data?.[0]?.teamDetail?.coachName;
        // team status
        _data.teamStatus = teamData?.data?.data?.[0]?.status;
        _data.teamDescription = teamData?.data?.data?.[0]?.teamDetail?.teamDescription;
        _data.teamPoints = teamData?.data?.data
          ?.filter((participant: DynamicObjectInterface) => participant.status === 'ACTIVE')
          ?.map((participant: DynamicObjectInterface) => participant.point)
          ?.flatMap((item: DynamicObjectInterface) => Object.values(item))
          ?.reduce((acc: number, value: number) => acc + value, 0);
        // _data.teamLeaderLoginId = teamData?.data?.data?.[0]?.teamDetail?.teamLeaderLoginId;
      }
      setFormData((i: DynamicObjectInterface) => {
        i = { ...modifiedData };
        i.subscribe = modifiedData.subscribe;
        return { ...i };
      });
    }

    if (isCoach) {
      let res = await apiCall(
        CoachService?.getCoachDetailByCampaignId,
        (
          campaignData[index].enrollment.find(enrollment => enrollment.enrollmentType === 'COACH')?.enrollmentId ?? ''
        ).toString(),
      );
      let coachData = res?.data?.data?.[0];
      if (!isParticipant) {
        _data = coachData;
      }

      if (_data) {
        if (!_data?.activities) _data.activities = [];
        _data.achievement = coachData?.achievement;
        _data.coachId = coachData?.coachId;
        _data.campaignName = coachData?.campaignName;
        _data.coachEnrollmentDate = coachData?.enrollmentDate;
        _data.coachEndDate = coachData?.endDate;
        _data.directLeaderName = coachData?.directLeaderName;
        _data.directLeader = coachData?.directLeader;

        if (!isLeader) {
          _data.cumulativePoint = coachData?.cumulativePoint;
          _data.newAboCount = coachData?.newAboCount;
          _data.newGroupAboCount = coachData?.newGroupAboCount;
          if (coachData?.rewards?.filter((i: DynamicObjectInterface) => i.rewardStatus === 'ACTIVE').length > 0) {
            _data.activities?.push({
              activityName: coachData?.rewards?.[0]?.activityName,
              reward: coachData?.rewards?.filter((i: DynamicObjectInterface) => i.rewardStatus === 'ACTIVE'),
              type: 'COACH',
            });
          }
        }
      }
    }

    if (isLeader) {
      let res = await apiCall(
        LeaderService.getLeaderDetailsByRecId,
        (
          campaignData[index].enrollment.find(enrollment => enrollment.enrollmentType === 'LEADER')?.enrollmentId ?? ''
        ).toString(),
      );
      let leaderData = res?.data?.data;
      if (!isParticipant && !isCoach) {
        _data = leaderData;
      }

      if (_data) {
        _data.totalAboReqruitment = leaderData?.totalAboReqruitment;
        _data.totalQualified = leaderData?.totalQualified;
        _data.totalPoint = leaderData?.totalPoint;
        _data.newGroupAboCount = leaderData?.newGroupAboCount;
        _data.summary = leaderData?.summary;

        if (!_data?.activities) _data.activities = [];

        if (leaderData?.rewards?.filter((i: DynamicObjectInterface) => i.rewardStatus === 'ACTIVE').length > 0) {
          _data.activities?.push({
            activityName: leaderData?.rewards?.[0]?.activityName,
            reward: leaderData?.rewards?.filter((i: DynamicObjectInterface) => i.rewardStatus === 'ACTIVE'),
            type: 'LEADER',
          });
        }

        if (isCoach) {
          _data.activities = _data?.activities?.filter(activity => activity.type !== 'COACH') || [];
        }
      }
    }

    const typeOrder: ActivityTypeOrder = { COACH: 0, LEADER: 1, PARTICIPANT: 2 };

    // Reorder activities, COACH/LEADER rewards followed by PARTICIPANT rewards
    _data?.activities?.sort((a, b) => {
      return typeOrder[a.type] - typeOrder[b.type];
    });
    setData(_data);

    let getCampaignDetail = await apiCall(
      CampaignService.getCampaignDetailByCampaignId,
      campaignData[index].campaignId,
    );
    setCampaignDetail(getCampaignDetail.data.data);
  };

  useEffect(() => {
    setIsParticipant(false);
    setIsCoach(false);
    setIsLeader(false);
    campaignData[index].enrollment.forEach(enrollment => {
      switch (enrollment?.enrollmentType) {
        case 'PARTICIPANT':
          setIsParticipant(true);
          break;
        case 'COACH':
          setIsCoach(true);
          break;
        case 'LEADER':
          setIsLeader(true);
          break;
      }
    });
    fetchData();
    const timeout = setTimeout(() => {
      trackPage(PAGES.campaignDashboard);
    }, 1000);
    return () => {
      clearTimeout(timeout);
    };
  }, [campaignData[index]?.campaignId]);

  // useEffect(() => {
  //   (async () => {
  //     let apiList = [apiCall(CoachService.getCoachList)];
  //     let res = await Promise.all(apiList);

  //     let coachData = res?.[0]?.data;

  //     let masterList = {
  //       coachList: [
  //         ...(coachData?.data || []).map((d: DynamicObjectInterface) => ({
  //           ...d,
  //           id: d.coachID,
  //           title: `${d.coachID} - ${d.name}`,
  //         })),
  //       ],
  //     };
  //     setMasterList(masterList);
  //   })();
  // }, []);

  useEffect(() => {
    if (data?.subscribe && data?.subscribe.length > 0) {
      setAlpValue(prev => ({ ...prev, input: data?.subscribe?.map(i => i.orderNumber)?.join(', ') ?? '' }));
    }
  }, [data?.subscribe]);

  const handleOnChange = async (value: DynamicObjectInterface, key: keyof UserData, ...paths: string[]) => {
    if (key === 'teamCoachId') {
      if (value.length === 10) {
        try {
          const response = await apiCall(CoachService.getNameByCoachId, campaignData[index].campaignId, value);
          if (response?.data?.data?.coachName) {
            setCoachName(response.data.data.coachName);
            setCoachInvalid(false);
          } else {
            setCoachInvalid(true);
            setCoachName('');
          }
        } catch (error) {
          setCoachName('');
          setCoachInvalid(true);
        }
      } else {
        setCoachInvalid(value.length !== 0);
        setCoachName('');
      }
    }

    setFormData(prev => {
      if (!prev) return { ...prev! };
      if (key === 'subscribe') {
        if (prev[key].length) {
          prev[key][0].orderNumber = value;
        } else {
          prev[key].push({
            orderNumber: value,
            orderPoint: 1,
          });
        }
        return { ...prev };
      } else if (key === 'subscribeCheck' && prev?.subscribeCheck === 'on') {
        return { ...(prev as UserData), [key]: '' };
      } else if (key === 'coachCheck' && prev?.coachCheck === 'on') {
        return { ...(prev as UserData), [key]: '' };
      } else {
        // if (!prev) return { ...prev! };

        const setDeep = (obj: DynamicObjectInterface, i = 0) => {
          if (paths.length !== i) {
            let path = i === 0 ? key : paths[i];
            let _obj = obj[path];
            if (_obj) obj = { ...obj, [path]: setDeep(_obj, i + 1) };
          } else {
            obj[paths[i - 1]] = value;
          }
          return obj;
        };

        if (paths.length > 0) {
          return setDeep(data) as UserData;
        } else {
          return { ...prev, [key]: value };
        }
      }
    });
  };

  const handleOnAlpChange = (value: DynamicObjectInterface, key: 'input' | 'check') => {
    setAlpValue(prev => {
      return {
        ...prev,
        [key]: value,
      };
    });
  };

  const rewardGiftModal = data?.activities?.map((activity, index) => {
    const hasReward = activity?.reward?.length > 0;

    return (
      hasReward && (
        <div key={index} className={styles['details-info-reward-list']}>
          <div className={styles['details-info-reward-title']}>{activity?.activityName}</div>
          <div>
            {activity?.reward?.map((reward, rewardIndex) => (
              <Fragment key={rewardIndex}>
                <div className={styles['details-info-reward-item']}>
                  <div className={styles['details-info-reward-label']}>{reward?.rewardName}</div>
                  <span className={styles['details-info-reward-value']}>
                    <Tag
                      theme={reward?.redeemDate ? Theme.GRAY : Theme.SUCCESS}
                      style={TagStyle.OUTLINE}
                      text={
                        reward?.redeemDate ? `REDEEMED (${formatDateDMYYYY(new Date(reward?.redeemDate))})` : 'ACTIVE'
                      }
                    />
                  </span>
                </div>
                {rewardIndex !== activity?.reward?.length - 1 && <div className={styles['horizontal-divider']} />}
              </Fragment>
            ))}
          </div>
        </div>
      )
    );
  });

  // const getButtonConfig = useMemo(() => {
  //   let commonConfig = {
  //     iconName: 'pencil' as IconName,
  //     iconStyle: IconStyle.SOLID,
  //     theme: Theme.WHITE,
  //     title: t('admin.participant.edit'),
  //   };

  //   // if (data?.coachEnrollmentDate || campaignData[index]?.isLeader) {
  //   // if ((data?.subscribe ?? [])?.length > 0) {
  //   return {
  //     alp: [{ ...commonConfig, onClick: () => setShowConfirmation(true) }],
  //   } as { [index: string]: IconButtonProps[] };
  //   // }
  //   // else {
  //   //   return {
  //   //     alp: [
  //   //       {
  //   //         title: isDesktopView ? 'Order No.' : 'ALP Order No.',
  //   //         icon: {
  //   //           iconName: 'square-plus',
  //   //           iconStyle: IconStyle.REGULAR,
  //   //         } as IconPropInterface,
  //   //         iconPosition: ButtonIconPosition.LEFT,
  //   //         buttonStyle: ButtonStyles.OUTLINE,
  //   //         theme: Theme.PURPLE,
  //   //         size: isDesktopView ? ButtonSize.SMALL : ButtonSize.EXTRA_SMALL,
  //   //         onClick: () => {
  //   //           setShowConfirmation(true);
  //   //         },
  //   //       },
  //   //     ],
  //   //   } as { [index: string]: ButtonPropsTypes[] };
  //   // }
  //   // }
  //   // else {
  //   //   return {};
  //   // }
  // }, [data]);

  // const getButtonLabelConfig = (
  //   <>
  //     {/* {(data?.coachEnrollmentDate || campaignData[index]?.isLeader) && ( */}
  //     <>
  //       <div className={isDesktopView ? styles['desktop-input-container'] : styles['mobile-input-container']}>
  //         {/* {isDesktopView ? <div className={styles['title']}>ALP Subscriptions :</div> : null} */}

  //         {(data?.subscribe ?? []).length > 0 && (
  //           <Input
  //             type={InputTypes.TEXT}
  //             name={'alp'}
  //             mlpVersion={MLPVersion.ONE}
  //             value={data?.subscribe?.map((i) => i.orderNumber)?.join(', ')}
  //             disabled={true}
  //           />
  //         )}
  //       </div>
  //     </>
  //     {/* )} */}
  //   </>
  // );

  const onSave = async () => {
    let payload = {
      campaignId: campaignData[index]?.campaignId,
      teamId: data?.teamId,
      allocation: {
        alp: {
          invoices: [
            {
              recId: formData?.subscribe[0]?.recId || null,
              orderPoint: 1,
              orderNumber: alpValue.input,
            },
          ],
        },
      },
    };

    const result = await apiCall(
      ParticipantService.updateParticipantDetails,
      {
        ...payload,
        section: 'pointAllocation',
      },
      decodedData.userId,
    );

    if (result.status === 200) {
      adminToast({
        message: t('admin.participant.updateSuccess'),
        theme: Theme.SUCCESS,
      });
      fetchData();
      setShowConfirmation(false);
    } else {
      adminToast({
        message: t('admin.participant.updateFail'),
        theme: Theme.ERROR,
      });
    }
  };

  const onSaveCoach = async () => {
    if (data?.teamId) {
      let payload = {
        teamId: data?.teamId,
        teamName: data?.teamName,
        description: data?.teamDescription,
        teamLeader: data?.teamLeaderLoginId,
        coachId: formData?.teamCoachId,
        isIndividualTeam: isIndividual === true ? 1 : 0,
        teamStartDate: data?.teamStartDate,
        teamEndDate: data?.teamEndDate,
        status: data?.teamStatus,
      };

      const result = await apiCall(TeamService.updateTeamCoach, data?.teamId, payload);

      if (result.status === 200) {
        adminToast({
          message: t('admin.participant.updateSuccess'),
          theme: Theme.SUCCESS,
        });
        fetchData();
        setShowCoachList(false);
      } else {
        adminToast({
          message: t('admin.participant.updateFail'),
          theme: Theme.ERROR,
        });
      }
    }
  };

  const fetchMeasurementImage = async () => {
    try {
      const payload = {
        campaignId: campaignData[index]?.campaignId,
        teamId: data?.teamId,
        loginId: decodedData.userId,
      };
      const response = await AttachmentService.downloadBeforeAfter(payload);

      // Validate response structure
      const imageData = response?.data?.data?.image || [];

      // Update state variables based on the downloaded image data
      const updatedImages: Record<string, AttachmentImageBA> = {
        before_front: { photoId: 0, url: '', file: null },
        after_front: { photoId: 0, url: '', file: null },
        before_side: { photoId: 0, url: '', file: null },
        after_side: { photoId: 0, url: '', file: null },
      };

      imageData.forEach((image: { photoId: number; photoType: string; url: string }) => {
        const { photoId, photoType, url } = image;
        if (Object.prototype.hasOwnProperty.call(updatedImages, photoType)) {
          updatedImages[photoType].url = url;
          updatedImages[photoType].photoId = photoId; // Assigning index from API response
        }
      });

      setImages(updatedImages);
    } catch (error) {
      LoggerService.log('Error downloading image', error);
    }
  };

  useEffect(() => {
    if (data?.teamId) {
      fetchMeasurementImage();
    }
  }, [data?.teamId]);

  // const searchCoach = (input: string) => {
  //   if (!input) {
  //     setFilteredCoachList(masterList?.coachList);
  //   } else {
  //     const filteredUsers = masterList?.coachList.filter((coach: DynamicObjectInterface) => {
  //       return coach.title.toLowerCase().includes(input.toLowerCase());
  //     });
  //     setFilteredCoachList(filteredUsers);
  //   }
  // };

  const confirmationPrompt = (
    <>
      {showConfirmation && (
        <Modal
          primaryButtonLabel={''}
          headline={'Add SOP Subscription Order Number'}
          children={
            <>
              <div
                style={{
                  fontSize: '16px',
                  fontFamily: 'GT-Walsheim-Pro-Bold, sans-serif',
                  lineHeight: '24px',
                  margin: '10px 0',
                }}
              >
                Enter your SOP Subscription Order Number
              </div>
              <Input
                type={InputTypes.TEXT}
                name={'orderNumber'}
                label={t('admin.participant.alpInvoiceNumber')}
                value={alpValue.input}
                mlpVersion={MLPVersion.ONE}
                onChange={e => handleOnAlpChange(e.target.value || null, 'input')}
              />
              <div style={{ display: 'flex', margin: '32px 0' }}>
                <Checkbox
                  key={'checkbox'}
                  className={styles['checkbox']}
                  checked={alpValue.check}
                  theme={Theme.BLACK}
                  text={
                    <p
                      id="agree-checkbox"
                      dangerouslySetInnerHTML={{
                        __html: t('admin.teamCreate.termsLine1').replace(
                          '{terms-conditions}',
                          `<a href="/terms-and-conditions?cid=${campaignData[index].campaignId}" target="_blank">${t('securityPrivacy.terms-condition')}</a>`,
                        ),
                      }}
                    />
                  }
                  onChange={e =>
                    handleOnAlpChange(alpValue.check ? !alpValue.check : true, 'check')
                  } /*handleOnAlpChange(e.target.value === 'on', 'check')*/
                />
                <>
                  {/* {t('admin.teamCreate.termsLine1')} */}
                  <br />
                  {/* {t('admin.teamCreate.termsLine2')} */}
                </>
              </div>
            </>
          }
          closeIcon={false}
          containerWidth={'max-content'}
          textAlign={TextAlign.LEFT}
          primaryButton={
            <Button
              title="Confirm"
              type={ButtonTypes.BUTTON}
              onClick={() => {
                onSave();
              }}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.SOLID}
              data-testid="test-add-button-popup"
              disabled={!alpValue.check}
            />
          }
          secondaryButton={
            <Button
              title="Cancel"
              type={ButtonTypes.BUTTON}
              onClick={() => {
                setAlpValue({ input: data?.subscribe?.map(i => i.orderNumber)?.join(', ') ?? '', check: false });
                setFormData(data);
                setShowConfirmation(false);
              }}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.OUTLINE}
              data-testid="test-cancel-button-popup-delete-modal"
            />
          }
        />
      )}
    </>
  );

  const coachSelectionPrompt = (
    <>
      {showCoachList && (
        <Modal
          primaryButtonLabel={''}
          headline={'Add Coach'}
          closeIcon={false}
          containerWidth="550px"
          textAlign={TextAlign.LEFT}
          primaryButton={
            <Button
              title="Confirm"
              type={ButtonTypes.BUTTON}
              onClick={() => {
                onSaveCoach();
              }}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.SOLID}
              data-testid="test-add-button-popup"
              disabled={!(formData?.teamCoachId && formData?.coachCheck === 'on') || coachInvalid}
            />
          }
          secondaryButton={
            <Button
              title="Cancel"
              type={ButtonTypes.BUTTON}
              onClick={() => {
                setFormData(data);
                setShowCoachList(false);
              }}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.OUTLINE}
              data-testid="test-cancel-button-popup-delete-modal"
            />
          }
        >
          <>
            <div
              style={{
                fontSize: '16px',
                fontFamily: 'GT-Walsheim-Pro-Bold, sans-serif',
                lineHeight: '24px',
                margin: '10px 0',
              }}
            ></div>
            <div className={styles['search-coach-container']}>
              {/* <SearchComponent
                label={t('admin.teams.coachId')}
                placeholder={t('admin.teams.searchCoach')}
                initialSearchText={
                  masterList?.coachList.find((c: DynamicObjectInterface) => c.id === data?.teamCoachId)?.title
                }
                status={InputValidations.DEFAULT}
                labelChoice={'title'}
                dropdownOptions={filteredCoachList}
                onSearch={searchCoach}
                onClear={() => {
                  searchCoach('');
                  handleOnChange('', 'teamCoachId');
                }}
                onSelect={e => {
                  handleOnChange(e.id, 'teamCoachId');
                }}
              /> */}
              <Input
                key={'team_add_coach'}
                type={InputTypes.TEXT}
                name={'coachId'}
                placeholder={t('admin.teams.searchCoach')}
                label={`${t('admin.teams.coachId')}`}
                value={coachName ? coachName : formData?.teamCoachId ? formData?.teamCoachId : ''}
                mlpVersion={MLPVersion.ONE}
                onChange={e => {
                  handleOnChange(e.target.value, 'teamCoachId');
                }}
                status={
                  coachInvalid
                    ? InputValidations.INVALID
                    : coachName.length > 0
                      ? InputValidations.VALID
                      : InputValidations.DEFAULT
                }
                message={coachInvalid ? `${t('admin.teamCreate.invalidCoachId')}` : ''}
              />
              {formData && formData.teamCoachId && formData.teamCoachId.length > 0 && (
                <FAIcon
                  className={styles['close-icon']}
                  iconStyle={IconStyle.SOLID}
                  data-testid="close-icon-test-id"
                  iconName={'close'}
                  theme={Theme.BLACK}
                  onClick={() => {
                    handleOnChange('', 'teamCoachId');
                  }}
                />
              )}
            </div>
            <div style={{ display: 'flex', margin: '32px 0' }}>
              <Checkbox
                key={'checkbox'}
                className={styles['checkbox']}
                checked={formData?.coachCheck === 'on'}
                theme={Theme.BLACK}
                text={
                  <p
                    id="agree-checkbox"
                    dangerouslySetInnerHTML={{
                      __html: t('admin.teamCreate.termsLine1').replace(
                        '{terms-conditions}',
                        `<a href="/terms-and-conditions?cid=${campaignData[index].campaignId}" target="_blank">${t('securityPrivacy.terms-condition')}</a>`,
                      ),
                    }}
                  />
                }
                onChange={e => handleOnChange(e.target.value, 'coachCheck')}
              />
              <>
                {/* {t('admin.teamCreate.termsLine1')} */}
                <br />
                {/* {t('admin.teamCreate.termsLine2')} */}
              </>
            </div>
          </>
        </Modal>
      )}
    </>
  );

  // const handleConfirmDetails = () => {
  //   setShowAcknowledgment(true);
  //   if (formData?.weightIn?.weightedDate && !formData?.weightIn?.acknowledgeBy) {
  //     setIsWeightInAcknowledged(true);
  //   }
  //   if (formData?.weightOut?.weightedDate && !formData?.weightOut?.acknowledgeBy) {
  //     setIsWeightOutAcknowledged(true);
  //   }
  //   if (
  //     formData?.weightIn?.weightedDate &&
  //     !formData?.weightIn?.acknowledgeBy &&
  //     formData?.weightOut?.weightedDate &&
  //     !formData?.weightOut?.acknowledgeBy
  //   ) {
  //     setIsWeightInAcknowledged(true);
  //     setIsWeightOutAcknowledged(true);
  //   }
  // };

  // const acknowledgeParticipant = async () => {
  //   const payload: AcknowledgePayload[] = [];

  //   if (isWeightInAcknowledged) {
  //     payload.push({
  //       userId: decodedData.userId,
  //       campaignId: campaignData[index]?.campaignId,
  //       action: 'WEIGHT_IN',
  //       remarks: formData?.weightIn?.remarks ?? '',
  //       name: decodedData.name,
  //       teamId: campaignData[index].enrollment.find(enrollment => enrollment.enrollmentType === 'PARTICIPANT')?.teamId,
  //     });
  //   }

  //   if (isWeightOutAcknowledged) {
  //     payload.push({
  //       userId: decodedData.userId,
  //       campaignId: campaignData[index]?.campaignId,
  //       action: 'WEIGHT_OUT',
  //       remarks: formData?.weightOut?.remarks ?? '',
  //       name: decodedData.name,
  //       teamId: campaignData[index].enrollment.find(enrollment => enrollment.enrollmentType === 'PARTICIPANT')?.teamId,
  //     });
  //   }

  //   const acknowledgeResponse = await apiCall(AcknowledgementService.acknowledge, `${decodedData.userId}`, payload);

  //   if (acknowledgeResponse.status === 200) {
  //     setShowAcknowledgment(false);

  //     adminToast({
  //       message: t('admin.dashboard.acknowledgeSucsess'),
  //       theme: Theme.SUCCESS,
  //     });
  //     fetchData();
  //   } else {
  //     adminToast({
  //       message: t('admin.teamEdit.acknowledgeError'),
  //       theme: Theme.ERROR,
  //     });
  //   }
  // };

  // const acknowledgment = (
  //   <>
  //     {showAcknowledgment && (
  //       <Modal
  //         primaryButtonLabel={''}
  //         headline={t('admin.teamEdit.headline')}
  //         closeIcon={false}
  //         containerWidth={ipadDimensions ? '750px' : '1000px'}
  //         textAlign={TextAlign.LEFT}
  //         primaryButton={
  //           <Button
  //             title={t('admin.userSetup.confirm')}
  //             type={ButtonTypes.BUTTON}
  //             onClick={() => {
  //               acknowledgeParticipant();
  //               setShowAcknowledgment(false);
  //             }}
  //             disabled={confirmCheck}
  //             size={ButtonSize.SMALL}
  //             buttonStyle={ButtonStyles.SOLID}
  //             data-testid="test-add-button-popup"
  //           />
  //         }
  //         secondaryButton={
  //           <Button
  //             title={t('admin.userSetup.cancel')}
  //             type={ButtonTypes.BUTTON}
  //             onClick={() => {
  //               setShowAcknowledgment(false);
  //             }}
  //             size={ButtonSize.SMALL}
  //             buttonStyle={ButtonStyles.OUTLINE}
  //             data-testid="test-cancel-button-popup-delete-modal"
  //           />
  //         }
  //       >
  //         <div className={style['participant-confirm-model']}>
  //           <div className={style['input-row']}>
  //             <div className={style['input-container']}>
  //               <div className={style['participant-weight-details']}>Pre-Assessment Measurement</div>
  //               <table>
  //                 <tbody>
  //                   <tr>
  //                     <td>Name</td>
  //                     <td className={style['colon-gap-name']}>:</td>
  //                     <td>{formData?.name}</td>
  //                   </tr>
  //                   <tr>
  //                     <td>Date</td>
  //                     <td className={style['colon-gap-date']}>:</td>
  //                     <td>
  //                       {formData?.weightIn?.weightedDate
  //                         ? formatDateDMYYYY(new Date(formData.weightIn.weightedDate))
  //                         : '-'}
  //                     </td>
  //                   </tr>
  //                   <tr>
  //                     <td>Height</td>
  //                     <td className={style['colon-gap-height']}>:</td>
  //                     <td>{formData?.weightIn?.height || '-'}</td>
  //                   </tr>
  //                   <tr>
  //                     <td>Weight</td>
  //                     <td className={style['colon-gap-body-weight']}>:</td>
  //                     <td>{formData?.weightIn?.weight || '-'}</td>
  //                   </tr>
  //                   <tr>
  //                     <td>Body Fat</td>
  //                     <td className={style['colon-gap-body-fat']}>:</td>
  //                     <td>{formData?.weightIn?.bodyFat || '-'}</td>
  //                   </tr>
  //                   <tr>
  //                     <td>Muscle Mass (kg)</td>
  //                     <td className={style['colon-gap-muscle-kg']}>:</td>
  //                     <td>{formData?.weightIn?.muscleKilogram || '-'}</td>
  //                   </tr>
  //                   <tr>
  //                     <td>Muscle Mass (%)</td>
  //                     <td className={style['colon-gap-muscle-kg1']}>:</td>
  //                     <td>{formData?.weightIn?.musclePercentage || '-'}</td>
  //                   </tr>
  //                   <tr>
  //                     <td>Remarks (if any)</td>
  //                     <td className={style['colon-gap-remarks']}>:</td>
  //                     <td>
  //                       <TextArea
  //                         resize={false}
  //                         mlpVersion={MLPVersion.ONE}
  //                         placeholder={'Remarks'}
  //                         value={formData?.weightIn?.remarks ?? ''}
  //                         onChange={e => {
  //                           handleOnChange(e.target.value, 'weightIn', 'remarks');
  //                         }}
  //                         disabled={!isWeightInAcknowledged}
  //                       />
  //                     </td>
  //                   </tr>
  //                 </tbody>
  //               </table>
  //             </div>

  //             <div className={style['input-container']}>
  //               <div className={style['participant-weight-details']}>Post-Assessment Measurement</div>
  //               <table>
  //                 <tbody>
  //                   <tr>
  //                     <td>Name</td>
  //                     <td className={style['colon-gap-name']}>:</td>
  //                     <td>{formData?.name}</td>
  //                   </tr>
  //                   <tr>
  //                     <td>Date</td>
  //                     <td className={style['colon-gap-date']}>:</td>
  //                     <td>
  //                       {formData?.weightOut?.weightedDate
  //                         ? formatDateDMYYYY(new Date(formData.weightOut.weightedDate))
  //                         : '-'}
  //                     </td>
  //                   </tr>
  //                   <tr>
  //                     <td>Height</td>
  //                     <td className={style['colon-gap-height']}>:</td>
  //                     <td>{formData?.weightOut?.height || '-'}</td>
  //                   </tr>
  //                   <tr>
  //                     <td>Weight</td>
  //                     <td className={style['colon-gap-body-weight']}>:</td>
  //                     <td>{formData?.weightOut?.weight || '-'}</td>
  //                   </tr>
  //                   <tr>
  //                     <td>Body Fat</td>
  //                     <td className={style['colon-gap-body-fat']}>:</td>
  //                     <td>{formData?.weightOut?.bodyFat || '-'}</td>
  //                   </tr>
  //                   <tr>
  //                     <td>Muscle Mass (kg)</td>
  //                     <td className={style['colon-gap-muscle-kg']}>:</td>
  //                     <td>{formData?.weightOut?.muscleKilogram || '-'}</td>
  //                   </tr>
  //                   <tr>
  //                     <td>Muscle Mass (%)</td>
  //                     <td className={style['colon-gap-muscle-kg1']}>:</td>
  //                     <td>{formData?.weightOut?.musclePercentage || '-'}</td>
  //                   </tr>
  //                   <tr>
  //                     <td>Remarks (if any)</td>
  //                     <td className={style['colon-gap-remarks']}>:</td>
  //                     <td>
  //                       <TextArea
  //                         resize={false}
  //                         mlpVersion={MLPVersion.ONE}
  //                         placeholder={'Remarks'}
  //                         value={formData?.weightOut?.remarks ?? ''}
  //                         onChange={e => {
  //                           handleOnChange(e.target.value, 'weightOut', 'remarks');
  //                         }}
  //                         disabled={!isWeightOutAcknowledged}
  //                       />
  //                     </td>
  //                   </tr>
  //                 </tbody>
  //               </table>
  //             </div>
  //           </div>

  //           <div className={style['input-row']}>
  //             <div className={style['checkbox-container']}>
  //               <div className={style['confirmation-checkbox']}>
  //                 <Checkbox text="" checked={!confirmCheck} onChange={() => setConfirmCheck(!confirmCheck)} />
  //                 <div className={style['confirmation-text']}>I verify that the information above is accurate.</div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </Modal>
  //     )}
  //   </>
  // );

  const RoleList = (): string => {
    let roles: string[] = [];

    if (campaignData[index]?.enrollment?.length > 0) {
      const additionalRoles = campaignData[index].enrollment
        .map(enrollment => {
          if (enrollment.enrollmentType === 'PARTICIPANT') return 'Participant';
          if (enrollment.enrollmentType === 'COACH') return 'Coach';
          if (enrollment.enrollmentType === 'LEADER') return 'Leader';
          return null;
        })
        .filter(role => role !== null) as string[];

      if (additionalRoles.length > 0) {
        roles = additionalRoles;
      }
    }

    return roles.join(', ');
  };

  const [actionMenu, setActionMenu] = useState(false);
  const [healthGoalData, setHealthGoalData] = useState('');
  const [userAnswerData, setUserAnswerData] = useState<UserAnswerDataType>();
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [healthQuestionData, setHealthQuestionData] = useState<CampaignQuestionType>();
  const [addHealthGoalModal, setAddHealthGoalModal] = useState(false);
  const menu = (
    <>
      {actionMenu && (
        <Menu
          menuItems={[
            {
              id: 'edit',
              title: 'Edit',
              onClick: () => {
                setAddHealthGoalModal(true);
              },
            },
            {
              id: 'delete',
              title: 'Delete',
              onClick: () => {
                saveHealthGoal(true);
                getUserAnswer();
              },
            },
          ]}
          onClose={() => {
            setActionMenu(false);
          }}
          className={styles['menu']}
        />
      )}
    </>
  );

  const handleTextAreaInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setHealthGoalData(e.target.value);
  };

  const saveHealthGoal = async (deleteText: boolean | undefined = false) => {
    const selectedQuestion = healthQuestionData ? healthQuestionData : null;

    try {
      const payload = {
        userId: decodedData.userId,
        faqId: selectedQuestion?.questionRecId,
        answerText: deleteText ? null : healthGoalData,
        options: selectedQuestion?.options,
        campaignId: campaignData[index].campaignId,
        recId: userAnswerData?.answerId,
      };
      const response = isUpdateMode
        ? await healthGoalService.updateHealthGoal(payload)
        : await healthGoalService.addHealthGoal(payload);
      if (response.status === 200) {
        setAddHealthGoalModal(false);
        adminToast({
          message: deleteText
            ? t('Successfully deleted health goal')
            : isUpdateMode
              ? t('Successfully updated health goal')
              : t('Successfully saved health goal'),
          theme: deleteText ? Theme.WARNING : Theme.SUCCESS,
        });
        getUserAnswer();
      }
    } catch (error) {
      LoggerService.log('Error uploading data', error);
    }
  };

  const getCampaignQuestion = async () => {
    try {
      const payload = {
        campaignId: '',
      };
      const response = await healthGoalService.campaignQuestion(payload);
      setHealthQuestionData(response.data.data);
    } catch (error) {
      LoggerService.log('Error retrieving question', error);
    }
  };

  const getUserAnswer = async () => {
    try {
      const payload = {
        userId: decodedData.userId,
        campaignId: campaignData[index]?.campaignId,
      };
      const response = await healthGoalService.userAnswer(payload);
      if (response.status === 200) {
        setUserAnswerData(response.data.data);
        if (response.data.data !== null) {
          setHealthGoalData(response.data.data.answerText);
          setIsUpdateMode(true);
        }
      }
    } catch (error) {
      LoggerService.log('Error retrieving question', error);
    }
  };

  const healthGoalModal = (
    <>
      {addHealthGoalModal &&
        (isDesktopView ? (
          <Modal
            primaryButtonLabel={''}
            headline={
              <div className={styles['progress-monitoring-title-container']}>
                <div className={styles['progress-monitoring-title-container-title']}>Health Goal</div>
                <div className={styles['progress-monitoring-title-container-subtitle']}>(Optional)</div>
                <Tooltip
                  message={
                    'Health goals are optional and are intended for your personal records to help you stay focused throughout the journey.'
                  }
                  preference={TooltipPreference.RIGHT}
                  className={styles['input-tool-tip']}
                  messageClassName={styles['input-tool-tip-message']}
                />
              </div>
            }
            children={
              <>
                <TextArea
                  mlpVersion={MLPVersion.ONE}
                  placeholder={t('Describe your health goal.   \nE.g: I want to lose 5 kg in 3 months')}
                  resize={false}
                  value={healthGoalData}
                  onChange={handleTextAreaInput}
                />
              </>
            }
            closeIcon={false}
            containerWidth={'398px'}
            textAlign={TextAlign.LEFT}
            buttonHorizontalAlignment={TextAlign.RIGHT}
            primaryButton={
              <Button
                title="Save goals"
                type={ButtonTypes.BUTTON}
                onClick={() => {
                  saveHealthGoal();
                }}
                size={ButtonSize.MEDIUM}
                buttonStyle={ButtonStyles.SOLID}
              />
            }
            secondaryButton={
              <Button
                title="Cancel"
                type={ButtonTypes.BUTTON}
                onClick={() => {
                  setAddHealthGoalModal(false);
                }}
                size={ButtonSize.MEDIUM}
                buttonStyle={ButtonStyles.OUTLINE}
                data-testid="test-cancel-button-popup-delete-modal"
              />
            }
          />
        ) : (
          <Drawer
            onClose={() => setAddHealthGoalModal(false)}
            header={'Add New Goals'}
            className={styles['mobile-drawer']}
            closeOnBackdropClick={true}
            // closeIcon={true}
            bottomGap={0}
            footer={
              <div className={styles['drawer-buttons']}>
                <Button
                  title="Cancel"
                  type={ButtonTypes.BUTTON}
                  onClick={() => {
                    setAddHealthGoalModal(false);
                  }}
                  size={ButtonSize.MEDIUM}
                  buttonWidth={ButtonWidth.FULL_WIDTH}
                  buttonStyle={ButtonStyles.OUTLINE}
                  className={styles['button-cancel']}
                />
                <Button
                  title="Save"
                  type={ButtonTypes.BUTTON}
                  onClick={() => {
                    saveHealthGoal();
                  }}
                  buttonWidth={ButtonWidth.FULL_WIDTH}
                  size={ButtonSize.MEDIUM}
                  buttonStyle={ButtonStyles.SOLID}
                />
              </div>
            }
          >
            <div className={styles['text-area-mobile']}>
              <TextArea
                mlpVersion={MLPVersion.ONE}
                placeholder={t('Describe your health goal.   \nE.g: I want to lose 5 kg in 3 months')}
                resize={false}
                value={healthGoalData}
                className={styles['text-area-mobile-input']}
                onChange={handleTextAreaInput}
              />
            </div>
          </Drawer>
        ))}
    </>
  );

  const [campaignIconURL, setCampaignIconURL] = useState('');
  const cacheKey = 'CampaignIconURL';
  const getCampaignIcon = async () => {
    try {
      const data = await getContent('challenge_details', cacheKey, true);
      if (data && data.length > 0) {
        const challenge = data.find((item: ContentItem) => item.campaign_id === campaignData[index].campaignId);
        setCampaignIconURL(challenge.challenge_icon.url || '');
      }
    } catch (error) {
      LoggerService.log('getCampaignIcon:Failed to retrieve content data. Using default content.');
    }
  };

  useEffect(() => {
    getCampaignIcon();
    getCampaignQuestion();
    getUserAnswer();
  }, [location]);

  const formatCampaignDescription = (description: string) => {
    return description.split('\n').map((line, index) => (
      <div className={styles['formatted-description']} key={index}>
        {line}
      </div>
    ));
  };

  const userDetail = (
    <Card containerHeight="100%">
      {/* campaign details section */}
      <div className={styles['campaign-container']}>
        {isDesktopView ? (
          <>
            <div className={styles['campaign-container-campaign-info']}>
              <div className={styles['campaign-container-details-info-header-container']}>
                <div className={styles['campaign-container-details-info-blank']}></div>
                <div className={styles['campaign-container-details-info-header']}>{t('Campaign Details')}</div>
              </div>
              <div className={styles['campaign-container-info-container']}>
                <div className={styles['img-container']}>
                  <img
                    src={campaignIconURL !== '' ? campaignIconURL : CampaignLogo}
                    alt="personalize"
                    className={styles['profile-image']}
                  />
                </div>
                <div className={styles['campaign-container-info-container-left']}>
                  <div className={styles['campaign-container-content-top']}>
                    <div className={styles['campaign-container-subtitle']}>Campaign</div>
                    <div className={styles['campaign-container-content']}>
                      {campaignData[index]?.campaignName ?? ''}
                    </div>
                  </div>
                  <div>
                    <div className={styles['campaign-container-subtitle']}>Period</div>
                    <div
                      className={styles['campaign-container-content']}
                    >{`${dateTimeToCustomFormat(campaignDetail?.campaignStart.toString() ?? '', 'DD/MM/YY')} - ${dateTimeToCustomFormat(campaignDetail?.campaignEnd.toString() ?? '', 'DD/MM/YY')}`}</div>
                  </div>
                </div>
                <div className={styles['vertical-line']} />
                <div className={styles['campaign-container-info-container-left-right']}>
                  <div className={styles['campaign-container-subtitle']}>Campaign Info</div>
                  <div className={styles['campaign-container-content']}>
                    {campaignDetail?.campaignDescription
                      ? formatCampaignDescription(campaignDetail.campaignDescription)
                      : ''}
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className={styles['campaign-container-details-info-header-container']}>
              <div className={styles['campaign-container-details-info-blank']}></div>
              <div className={styles['campaign-container-details-info-header']}>{t('Campaign Details')}</div>
            </div>
            <div className={styles['campaign-container-mobile-container-outer']}>
              <div className={styles['campaign-container-mobile-container']}>
                <div className={styles['campaign-container-details-mobile-container']}>
                  <div className={styles['img-container-alt']}>
                    <img
                      src={campaignIconURL !== '' ? campaignIconURL : CampaignLogo}
                      alt="personalize"
                      className={styles['profile-image']}
                    />
                  </div>
                  <div className={styles['campaign-container-info-container-left']}>
                    <div className={styles['campaign-container-content-top']}>
                      <div className={styles['campaign-container-subtitle']}>Campaign</div>
                      <div className={styles['campaign-container-content']}>
                        {campaignData[index]?.campaignName ?? ''}
                      </div>
                    </div>
                    <div>
                      <div className={styles['campaign-container-subtitle']}>Period</div>
                      <div
                        className={styles['campaign-container-content']}
                      >{`${dateTimeToCustomFormat(data?.campaign?.campaignStart.toString() ?? '', 'DD/MM/YY')} - ${dateTimeToCustomFormat(data?.campaign?.campaignEnd.toString() ?? '', 'DD/MM/YY')}`}</div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div>
                <div className={styles['campaign-container-subtitle']}>Campaign Info</div>
                <div className={styles['campaign-container-content']}>
                  {data?.campaign?.campaignDescription && formatCampaignDescription(data.campaign.campaignDescription)}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className={`${styles['details']} ${isCoach && styles['details-flex']}`}>
        <div className={styles['details-info']}>
          <div className={styles['details-info-item']}>
            <div className={styles['label']}>{t('My Role')}</div>
            <div className={styles['label-content']}>{RoleList()}</div>
          </div>
          {isParticipant && (
            <div className={styles['details-info-item']}>
              <div className={styles['label']}>{t('SOP Subscription (Optional)')}</div>
              {(data?.subscribe ?? [])?.length > 0 ? (
                <div className={styles['label-content']}>
                  {data?.subscribe.map(subscription => subscription.orderNumber).join(', ')}
                </div>
              ) : (
                <button className={styles['alp-button']} onClick={() => setShowConfirmation(true)}>
                  <img className={styles['square-icon']} src={LayerSquarePlus} alt={'plus'} />
                  <p className={styles['invoice-text']}>{'Add Order Number'}</p>
                </button>
              )}
            </div>
          )}
        </div>
        {isCoach && (
          <>
            <div className={styles['vertical-line-empty']} />
            <div className={styles['details-info']}>
              <div className={styles['details-info-item']}>
                <div className={styles['label']}>{t('admin.dashboard.coachId')}</div>
                <div className={styles['label-content']}>{data?.coachId ?? '-'}</div>
              </div>
              <div className={styles['details-info-item']}>
                <div className={styles['label']}>{t('admin.dashboard.coachDeclarePeriod')}</div>
                <div className={styles['label-content']}>
                  {data?.coachEnrollmentDate
                    ? dateTimeToCustomFormat(data?.coachEnrollmentDate?.toString() ?? '', 'MMM YYYY') +
                      ' - ' +
                      dateTimeToCustomFormat(data?.coachEndDate?.toString() ?? '', 'MMM YYYY')
                    : '-'}
                </div>
              </div>
              <div className={styles['details-info-item']}>
                <div className={styles['label']}>{t('admin.dashboard.directLeaderName')}</div>
                <div className={styles['label-content']}>{data?.directLeaderName ?? '-'}</div>
              </div>
              <div className={styles['details-info-item']}>
                <div className={styles['label']}>{t('admin.dashboard.directLeader')}</div>
                <div className={styles['label-content']}>{data?.directLeader ?? '-'}</div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className={styles['progress-monitoring-horizontal-line']} />
      {/* health goal section  */}
      <div>
        <div className={styles['progress-monitoring-title-container']}>
          <div className={styles['progress-monitoring-title-container-title']}>Health Goal</div>
          <div className={styles['progress-monitoring-title-container-subtitle']}>(Optional)</div>
          <Tooltip
            message={
              'Health goals are optional and are intended for your personal records to help you stay focused throughout the journey.'
            }
            preference={TooltipPreference.RIGHT}
            className={styles['input-tool-tip']}
          />
        </div>
        {userAnswerData?.answerText !== undefined && userAnswerData?.answerText !== null ? (
          <div className={styles['health-goal-section']}>
            <div className={styles['health-goal-content']}>{userAnswerData?.answerText}</div>
            <div className={styles['health-goal-button-section']}>
              <button
                onClick={event => {
                  event.stopPropagation();
                  setActionMenu(true);
                }}
                className={`${styles['health-goal-button']}`}
              >
                ...
              </button>
              {menu}
            </div>
          </div>
        ) : (
          <div className={styles['health-goal-add-goals']}>
            <Button
              size={ButtonSize.SMALL}
              className={styles['health-goal-button-styles']}
              title={'+ Add Goals'}
              onClick={() => {
                setAddHealthGoalModal(true);
              }}
              buttonWidth={ButtonWidth.FULL_WIDTH}
              buttonStyle={ButtonStyles.OUTLINE}
            />
          </div>
        )}
      </div>
      {healthGoalModal}
    </Card>
  );

  const handleImageUpload = (type: string) => {
    setIsOpen(true);
    setCarouselType(type);
  };

  const handleCloseModal = () => {
    setIsImageUploaded(false);
    setIsOpen(false);
    if (!isImageUploaded) {
      fetchMeasurementImage();
    }
  };

  const handleFileImage = (e: customEventPropType, view: string, isBefore: boolean) => {
    const file = e.files[0];
    // Check if the user has selected a file
    if (file) {
      const imageUrlSetter = isBefore ? 'before' : 'after';
      const imageStateSetter = view === 'front' ? 'front' : 'side';

      // Check if the original filename is "image.jpg"
      const originalFileName = file.name;
      const isOriginalImageName = originalFileName === 'image.jpg';

      // Get current date and time to create a unique filename
      const currentDate = new Date();
      const timestamp = currentDate.getTime(); // Get timestamp in milliseconds
      const extension = file.name.split('.').pop(); // Get the file extension

      let newFileName = originalFileName; // Default to original filename
      if (isOriginalImageName) {
        newFileName = `${timestamp}.${extension}`; // Create new filename with timestamp
      }

      setImages((prevImages: Record<string, AttachmentImageBA>) => ({
        ...prevImages,
        [`${imageUrlSetter}_${imageStateSetter}`]: {
          photoId: prevImages[`${imageUrlSetter}_${imageStateSetter}`].photoId,
          url: URL.createObjectURL(file),
          file: new File([file], newFileName), // Create a new File object with the renamed file if needed
        },
      }));
      setIsImageUploaded(true);
    }
  };

  const handleRemoveImage = (imageUrlSetter: string, imageStateSetter: string) => {
    setImages((prevImages: Record<string, AttachmentImageBA>) => ({
      ...prevImages,
      [`${imageUrlSetter}_${imageStateSetter}`]: {
        photoId: prevImages[`${imageUrlSetter}_${imageStateSetter}`].photoId,
        url: '',
        file: null,
      },
    }));
  };

  const handleFile = (e: ChangeEvent<HTMLInputElement>, key: string, isBefore: boolean) => {
    const file = e.target.files?.[0] as File | null;
    if (file) {
      const url: string = URL.createObjectURL(file);
      setImages(prevImages => ({
        ...prevImages,
        [key]: { ...prevImages[key], file, url },
      }));
    }
  };

  const handleFileUpload = async () => {
    try {
      const formData = processBeforeAfterImagesData(
        images,
        campaignData[index]?.campaignId,
        String(data?.teamId),
        decodedData.userId,
      );
      const response = await apiCall(() => AttachmentService.postUploadBeforeAfter(formData));
      if (response.status === 200) {
        const newImages = processBeforeAfterImagesResponse(response, images);
        setImages({ ...newImages });

        handleCloseModal();
        LoggerService.log('Successfully uploading image', response);
      }
    } catch (error) {
      LoggerService.log('Error uploading image', error);
    }
  };

  const [openProgressModal, setOpenProgressModal] = useState(false);
  const [deleteProgressModal, setDeleteProgressModal] = useState(false);
  const [disabledDates, setDisabledDates] = useState<Date[]>([]);
  // const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [singleProgressData, setSingleProgressData] = useState<ProgressType>({
    weighingDate: new Date(),
    weight: 0,
    bodyFat: 0,
    muscleKilogram: 0,
    checked: false,
  });
  const [progressData, setProgressData] = useState<ProgressType[]>([]);
  const [progressRowRecId, setProgressRowRecId] = useState<{
    rowObject?: DynamicObjectInterface;
    index?: DynamicObjectInterface;
  }>({});

  const handleProgressUpdate = (name: string, value: DynamicObjectInterface) => {
    setSingleProgressData(prevProgressData => ({
      ...prevProgressData!,
      [name]: value,
    }));
  };

  const fetchProgressMonitoringList = async () => {
    const info = {
      loginId: decodedData.loginId,
      userId: decodedData.userId,
      campaignId: campaignData[index]?.campaignId,
    };

    try {
      const result = await apiCall(intermediateMeasurementService.getIntermediateMeasurementList, info);
      setProgressData(result?.data?.data);
    } catch (error) {
      LoggerService.log('Failed to retrieve campaign list', error);
    }
  };

  useEffect(() => {
    fetchProgressMonitoringList();
  }, []);

  const handleSaveProgressDetails = async () => {
    const payload = {
      loginId: decodedData.loginId,
      userId: decodedData.userId,
      campaignId: campaignData[index]?.campaignId,
      weightMachine: data?.weightIn?.machine,
      height: encryptString(data?.weightIn?.height.toString() ?? ''),
      weight: encryptString(singleProgressData.weight.toString()),
      bodyFat: encryptString(singleProgressData.bodyFat.toString()),
      muscleKilogram: encryptString(singleProgressData.muscleKilogram.toString()),
      musclePercentage: null,
      remarks: '',
      teamId: data?.teamId,
      weighingDate: dateTimeToCustomFormat(singleProgressData.weighingDate.toString(), 'YYYY-MM-DD'),
      acknowledgedDate: dateTimeToCustomFormat(new Date().toString(), 'YYYY-MM-DD'),
      acknowledgeBy: decodedData.userId,
    };

    const result = await apiCall(intermediateMeasurementService.addIntermediateMeasurement, payload);

    if (result.status === 200) {
      adminToast({
        message: t('Successfully added your new progress details'),
        theme: Theme.SUCCESS,
      });
      fetchProgressMonitoringList();
      setOpenProgressModal(false);
      setSingleProgressData({
        weighingDate: new Date(),
        weight: 0,
        bodyFat: 0,
        muscleKilogram: 0,
        checked: false,
      });
    } else {
      adminToast({
        message: t('admin.participant.updateFail'),
        theme: Theme.ERROR,
      });
    }
  };

  const progressMonitorConfig = [
    {
      key: 'weighingDate',
      text: 'Date',
      sortable: true,
      width: 25,
      render: (object: DynamicObjectInterface) => {
        return <span>{dateTimeToCustomFormat(object.weighingDate, 'DD/MM/YYYY')}</span>;
      },
    },
    {
      key: 'weight',
      text: 'Weight (kg)',
      sortable: false,
      width: 20,
      render: (object: DynamicObjectInterface) => (
        <span>{getRoundedNumber(parseFloat(decryptString(object.weight)))}</span>
      ),
    },
    {
      key: 'bodyFat',
      text: 'Body Fat (%)',
      sortable: false,
      width: 20,
      render: (object: DynamicObjectInterface) => (
        <span>{getRoundedNumber(parseFloat(decryptString(object.bodyFat)))}</span>
      ),
    },
    {
      key: 'muscleKilogram',
      text: 'Muscle Mass (kg)',
      sortable: false,
      width: 20,
      render: (object: DynamicObjectInterface) => (
        <span>{getRoundedNumber(parseFloat(decryptString(object.muscleKilogram)))}</span>
      ),
    },
  ];

  const handleDeleteProgress = async () => {
    const result = await apiCall(
      intermediateMeasurementService.deleteIntermediateMeasurement,
      progressRowRecId.rowObject.recId,
    );

    if (result.status === 200) {
      adminToast({
        message: t('Deleted the progress details'),
        theme: Theme.SUCCESS,
      });
      fetchProgressMonitoringList();
      setDeleteProgressModal(false);
    } else {
      adminToast({
        message: t('admin.participant.updateFail'),
        theme: Theme.ERROR,
      });
    }
  };

  const progressMenuItem: MenuItem[] = [
    {
      id: '0',
      title: 'Delete',
      onClick: () => setDeleteProgressModal(true),
    },
  ];

  const actionColCb = (rowObject: DynamicObjectInterface, index: DynamicObjectInterface) => {
    setProgressRowRecId({ rowObject, index });
  };

  const generateDisabledDates = (referenceDate: Date): Date[] => {
    const disabledDates: Date[] = [];
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Ensure 'today' is at midnight

    // The day before the reference date
    let inputDate = new Date(referenceDate);
    inputDate.setHours(0, 0, 0, 0);
    inputDate.setDate(inputDate.getDate() - 1);

    // Set the earliest date to consider
    const oneYearBefore = new Date(inputDate);
    oneYearBefore.setFullYear(oneYearBefore.getFullYear() - 1);

    // Collect all dates before the reference date
    while (inputDate >= oneYearBefore) {
      disabledDates.push(new Date(inputDate));
      inputDate.setDate(inputDate.getDate() - 1);
    }

    // Collect all dates after today
    let futureDate = new Date(today);
    futureDate.setDate(futureDate.getDate() + 1);

    // Loop until we reach a reasonable future limit
    const futureLimit = new Date(today);
    futureLimit.setFullYear(today.getFullYear() + 1);

    while (futureDate <= futureLimit) {
      disabledDates.push(new Date(futureDate));
      futureDate.setDate(futureDate.getDate() + 1);
    }

    if (progressData) {
      progressData.forEach(data => {
        const weightedDate = new Date(data.weighingDate);
        weightedDate.setHours(0, 0, 0, 0);
        disabledDates.push(weightedDate);
      });
    }

    // Convert to timestamp for comparison and uniqueness
    const uniqueDisabledDates = Array.from(new Set(disabledDates.map(date => date.getTime())));

    return uniqueDisabledDates.map(time => new Date(time));
  };

  useEffect(() => {
    if (formData?.weightIn?.weightedDate) {
      const referenceDate = new Date(formData.weightIn.weightedDate);
      const disabledDates = generateDisabledDates(referenceDate);
      setDisabledDates(disabledDates);
    }
  }, [formData, progressData]);

  const addProgress = (
    <>
      {openProgressModal &&
        (isDesktopView ? (
          <Modal
            headline={'Add New Progress'}
            textAlign={TextAlign.LEFT}
            containerWidth="750px"
            // containerHeight="800px"
            buttonHorizontalAlignment={TextAlign.RIGHT}
            closeIcon={false}
            primaryButton={
              <Button
                title={t('admin.userSetup.confirm')}
                type={ButtonTypes.BUTTON}
                onClick={() => {
                  handleSaveProgressDetails();
                }}
                size={ButtonSize.MEDIUM}
                disabled={
                  !singleProgressData.checked ||
                  !singleProgressData.weight ||
                  !singleProgressData.bodyFat ||
                  !singleProgressData.muscleKilogram
                }
                buttonStyle={ButtonStyles.SOLID}
              />
            }
            secondaryButton={
              <Button
                title={t('admin.userSetup.cancel')}
                type={ButtonTypes.BUTTON}
                onClick={() => {
                  setOpenProgressModal(false);
                }}
                size={ButtonSize.MEDIUM}
                buttonStyle={ButtonStyles.OUTLINE}
              />
            }
          >
            <div className={styles['progress-monitoring-modal']}>
              {/* top  */}
              <div className={styles['progress-monitoring-modal-top']}>
                Regularly track your health records to ensure you're progressing toward your goals. Monitoring your
                progress keeps you motivated and helps you make informed decisions about your health journey.
              </div>
              {/* center  */}
              <div className={styles['progress-monitoring-modal-center']}>
                <DatePicker
                  inputContainerHeight="40px"
                  showDateContainer
                  // calendarHeading={t('admin.campaignConfig.startDate')}
                  value={singleProgressData.weighingDate}
                  onChange={date => {
                    handleProgressUpdate('weighingDate', date);
                  }}
                  actionButtonStyle={{ padding: '5px 10px 0' }}
                  calendarContainerStyling={isDesktopView && { padding: '10px', top: '-300px', left: '210px' }}
                  menuContainerStyle={{ position: 'fixed', zIndex: 2 }}
                  required
                  containerWidth="450px"
                  inputLabel={`${t('Date')}`}
                  disabledDates={disabledDates}
                />
                <Input
                  type={InputTypes.NUMBER}
                  label={'Weight (kg)'}
                  name={'Weight (kg)'}
                  placeholder={'e.g. 75'}
                  mlpVersion={MLPVersion.ONE}
                  value={singleProgressData.weight || ''}
                  required
                  status={
                    singleProgressData.checked && !singleProgressData.weight
                      ? InputValidations.INVALID
                      : InputValidations.DEFAULT
                  }
                  message={singleProgressData.checked && !singleProgressData.weight ? 'This field is mandatory.' : ''}
                  onChange={e => handleProgressUpdate('weight', e.target.value)}
                />
                <Input
                  type={InputTypes.NUMBER}
                  label={'Body Fat (%)'}
                  name={'Body Fat (%)'}
                  mlpVersion={MLPVersion.ONE}
                  placeholder={'e.g. 30'}
                  value={singleProgressData.bodyFat || ''}
                  required
                  status={
                    singleProgressData.checked && !singleProgressData.bodyFat
                      ? InputValidations.INVALID
                      : InputValidations.DEFAULT
                  }
                  message={singleProgressData.checked && !singleProgressData.bodyFat ? 'This field is mandatory.' : ''}
                  onChange={e => handleProgressUpdate('bodyFat', e.target.value)}
                />
                <Input
                  type={InputTypes.NUMBER}
                  label={'Muscle Mass (kg)'}
                  name={'Muscle Mass (kg)'}
                  placeholder={'e.g. 30'}
                  mlpVersion={MLPVersion.ONE}
                  value={singleProgressData.muscleKilogram || ''}
                  required
                  status={
                    singleProgressData.checked && !singleProgressData.muscleKilogram
                      ? InputValidations.INVALID
                      : InputValidations.DEFAULT
                  }
                  message={
                    singleProgressData.checked && !singleProgressData.muscleKilogram ? 'This field is mandatory.' : ''
                  }
                  onChange={e => handleProgressUpdate('muscleKilogram', e.target.value)}
                />
              </div>
              {/* bottom  */}
              <div>
                <Checkbox
                  text={'I verify that the information provided is correct and I acknowledge the requirements.'}
                  checked={singleProgressData.checked}
                  onChange={e => {
                    // setCheckboxChecked(e.target.checked);
                    handleProgressUpdate('checked', e.target.checked);
                  }}
                />
              </div>
            </div>
          </Modal>
        ) : (
          <Drawer
            onClose={() => setAddHealthGoalModal(false)}
            header={'Add New Progress'}
            className={styles['mobile-drawer-log']}
            closeOnBackdropClick={true}
            // closeIcon={true}
            bottomGap={0}
            footer={
              <div className={styles['drawer-buttons']}>
                <div className={styles['button-cancel']}>
                  <Button
                    title={t('admin.userSetup.cancel')}
                    type={ButtonTypes.BUTTON}
                    onClick={() => {
                      setOpenProgressModal(false);
                    }}
                    size={ButtonSize.MEDIUM}
                    buttonStyle={ButtonStyles.OUTLINE}
                  />
                </div>
                <Button
                  title={t('admin.userSetup.confirm')}
                  type={ButtonTypes.BUTTON}
                  onClick={() => {
                    handleSaveProgressDetails();
                  }}
                  size={ButtonSize.MEDIUM}
                  disabled={!singleProgressData.checked}
                  buttonStyle={ButtonStyles.SOLID}
                />
              </div>
            }
          >
            <div className={styles['progress-monitoring-modal']}>
              {/* top  */}
              <div className={styles['progress-monitoring-modal-top']}>
                Regularly track your health records to ensure you're progressing toward your goals. Monitoring your
                progress keeps you motivated and helps you make informed decisions about your health journey.
              </div>
              {/* center  */}
              <div className={styles['progress-monitoring-modal-center']}>
                <div className={styles['progress-monitoring-modal-input']}>
                  <DatePicker
                    inputContainerHeight="40px"
                    showDateContainer
                    // calendarHeading={t('admin.campaignConfig.startDate')}
                    value={singleProgressData.weighingDate}
                    onChange={date => {
                      handleProgressUpdate('weighingDate', date);
                    }}
                    actionButtonStyle={{ padding: '5px 10px 0' }}
                    calendarContainerStyling={isDesktopView && { padding: '10px', top: '-300px', left: '210px' }}
                    menuContainerStyle={{ position: 'fixed', zIndex: 2 }}
                    required
                    containerWidth="450px"
                    inputLabel={`${t('Date')}`}
                    disabledDates={disabledDates}
                  />
                </div>
                <div className={styles['progress-monitoring-modal-input']}>
                  <Input
                    type={InputTypes.NUMBER}
                    label={'Weight (kg)'}
                    name={'Weight (kg)'}
                    mlpVersion={MLPVersion.ONE}
                    value={singleProgressData.weight}
                    required
                    onChange={e => handleProgressUpdate('weight', e.target.value)}
                  />
                </div>
                <div className={styles['progress-monitoring-modal-input']}>
                  <Input
                    type={InputTypes.NUMBER}
                    label={'Body Fat (%)'}
                    name={'Body Fat (%)'}
                    mlpVersion={MLPVersion.ONE}
                    value={singleProgressData.bodyFat}
                    required
                    onChange={e => handleProgressUpdate('bodyFat', e.target.value)}
                  />
                </div>
                <Input
                  type={InputTypes.NUMBER}
                  label={'Muscle Mass (kg)'}
                  name={'Muscle Mass (kg)'}
                  mlpVersion={MLPVersion.ONE}
                  value={singleProgressData.muscleKilogram}
                  required
                  onChange={e => handleProgressUpdate('muscleKilogram', e.target.value)}
                />
              </div>
              {/* bottom  */}
              <div>
                <Checkbox
                  text={'I verify that the information provided is correct and I acknowledge the requirements.'}
                  checked={singleProgressData.checked}
                  onChange={e => {
                    // setCheckboxChecked(e.target.checked);
                    handleProgressUpdate('checked', e.target.checked);
                  }}
                />
              </div>
            </div>
          </Drawer>
        ))}
    </>
  );

  const deleteProgress = (
    <>
      {deleteProgressModal && (
        <Modal
          headline={''}
          textAlign={TextAlign.CENTER}
          containerWidth="550px"
          buttonHorizontalAlignment={TextAlign.CENTER}
          closeIcon={false}
          primaryButton={
            <Button
              title={t('Delete')}
              type={ButtonTypes.BUTTON}
              onClick={() => {
                handleDeleteProgress();
                setDeleteProgressModal(false);
              }}
              buttonWidth={ButtonWidth.FIT_CONTENT}
              size={ButtonSize.MEDIUM}
              buttonStyle={ButtonStyles.SOLID}
            />
          }
          secondaryButton={
            <Button
              title={t('admin.userSetup.cancel')}
              type={ButtonTypes.BUTTON}
              onClick={() => {
                setDeleteProgressModal(false);
              }}
              buttonWidth={ButtonWidth.FIT_CONTENT}
              size={ButtonSize.MEDIUM}
              buttonStyle={ButtonStyles.OUTLINE}
            />
          }
        >
          <div className={styles['progress-monitoring-modal']}>
            {/* top  */}
            <img src={WarningIcon} alt={''} width={'61.5px'} height={'55px'} />
            <div className={styles['progress-monitoring-modal-top-title']}>
              Are you sure you want to delete the following progress?
            </div>
            <div className={styles['progress-monitoring-modal-top-subtitle']}>This process cannot be undone.</div>
            <div className={styles['progress-monitoring-modal-input-container']}>
              <div className={styles['progress-monitoring-modal-input-container-label']}>Name</div>
              <div className={styles['progress-monitoring-modal-input-container-data']}>{decodedData.name}</div>
            </div>
            <div className={styles['progress-monitoring-modal-input-container']}>
              <div className={styles['progress-monitoring-modal-input-container-label']}>Date</div>
              <div className={styles['progress-monitoring-modal-input-container-data']}>
                {dateTimeToCustomFormat(progressRowRecId.rowObject.weighingDate)}
              </div>
            </div>
            <div className={styles['progress-monitoring-modal-input-container']}>
              <div className={styles['progress-monitoring-modal-input-container-label']}>Weight (kg)</div>
              <div className={styles['progress-monitoring-modal-input-container-data']}>
                {decryptString(progressRowRecId.rowObject.weight)}
              </div>
            </div>
            <div className={styles['progress-monitoring-modal-input-container']}>
              <div className={styles['progress-monitoring-modal-input-container-label']}>Body Fat (%)</div>
              <div className={styles['progress-monitoring-modal-input-container-data']}>
                {decryptString(progressRowRecId.rowObject.bodyFat)}
              </div>
            </div>
            <div className={styles['progress-monitoring-modal-input-container']}>
              <div className={styles['progress-monitoring-modal-input-container-label']}>Muscle Mass (kg)</div>
              <div className={styles['progress-monitoring-modal-input-container-data']}>
                {decryptString(progressRowRecId.rowObject.muscleKilogram)}
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );

  const measurementDetail = (
    <Card
      title={t('admin.dashboard.measurement')}
      headerStyle={isDesktopView ? HeaderStyle.HEADER_5 : HeaderStyle.HEADER_6}
      // buttonType={ButtonType.ICON}
      // button={getButtonConfig.alp}
      // buttonLabel={getButtonLabelConfig}
    >
      {isDesktopView ? (
        <div className={styles['result-container']}>
          <div className={styles['measurement-wrap']}>
            <div className={styles['carousel-container']}>
              <ImageSlider
                id="beforeImg"
                slides={[
                  {
                    src: images.before_front.url ? images.before_front.url : PhotoUnavailable,
                    alt: 'Before Front View',
                  },
                  {
                    src: images.before_side.url ? images.before_side.url : PhotoUnavailable,
                    alt: 'Before Side View',
                  },
                ]}
                onClick={() => handleImageUpload('before')}
              />
              {/* <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.remark')}</div>
                <p>{data?.weightIn?.remarks ?? '-'}</p>
              </div> */}
            </div>
            <div className={styles['result-info']}>
              <div className={styles['title']}>{t('admin.participant.before')}</div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.weighInDate')}</div>
                {/* <div className={styles['tag-calendar']}> */}
                <div className={styles['tag-calendar']}>
                  {data?.weightIn?.weightedDate ? (
                    <Tag
                      theme={Theme.GRAY}
                      text={dateTimeToCustomFormat(data?.weightIn?.weightedDate ?? '', 'DD/MM/yyyy')}
                      style={TagStyle.OUTLINE}
                    />
                  ) : (
                    '-'
                  )}
                </div>
              </div>
              {/* </div> */}
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.machine')}</div>
                <p>{data?.weightIn?.machine ?? '-'}</p>
              </div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.height')}</div>
                <p>{data?.weightIn?.height ?? '-'}</p>
              </div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.weight')}</div>
                <p>{data?.weightIn?.weight}</p>
              </div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.muscleMassKg')}</div>
                <p>{data?.weightIn?.muscleKilogram}</p>
              </div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.muscleMassPercentage')}</div>
                <p>{data?.weightIn?.musclePercentage}</p>
              </div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.bodyFatPercentage')}</div>
                <p>{data?.weightIn?.bodyFat}</p>
              </div>
              <div className={styles['acknowledge-container']}>
                <div className={styles['label-container']}>
                  <div className={styles['label-small']}>{t('admin.participant.acknowledgedBy')}</div>
                  <p className={styles['label-small-ans']}>{data?.weightIn?.acknowledgeByName ?? '-'}</p>
                </div>

                <div className={styles['label-container-ack']}>
                  <div className={styles['label-ack-small']}>{t('admin.participant.acknowledgedDate')}</div>
                  <p className={styles['label-ack-small-ans']}>
                    {data?.weightIn?.acknowledgeDateTime
                      ? dateTimeToCustomFormat(data?.weightIn.acknowledgeDateTime ?? '', 'DD/MM/yyyy')
                      : '-'}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className={styles['measurement-wrap']}>
            <div className={styles['carousel-container']}>
              <ImageSlider
                id="afterImg"
                slides={[
                  {
                    src: images.after_front.url ? images.after_front.url : PhotoUnavailable,
                    alt: 'After Front View',
                  },
                  {
                    src: images.after_side.url ? images.after_side.url : PhotoUnavailable,
                    alt: 'Afer Side View',
                  },
                ]}
                onClick={() => handleImageUpload('after')}
              />
              {/* <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.remark')}</div>
                <p>{data?.weightOut?.remarks ?? '-'}</p>
              </div> */}
            </div>
            <div className={styles['result-info']}>
              <div className={styles['title']}>{t('admin.participant.after')}</div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.weighOutDate')}</div>
                <div className={styles['tag-calendar']}>
                  {data?.weightOut?.weightedDate ? (
                    <Tag
                      theme={Theme.GRAY}
                      text={dateTimeToCustomFormat(data?.weightOut?.weightedDate ?? '', 'DD/MM/yyyy')}
                      style={TagStyle.OUTLINE}
                    />
                  ) : (
                    '-'
                  )}
                </div>
              </div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.machine')}</div>
                <p>{data?.weightOut?.machine ?? '-'}</p>
              </div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.height')}</div>
                <p>{data?.weightOut?.height ?? '-'}</p>
              </div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.weight')}</div>
                <p>{data?.weightOut?.weight}</p>
                {data?.weightOutDiffValues?.weightDiff && data?.weightOut?.weightedDate ? (
                  <div
                    className={`${styles['difference-label']} ${
                      data?.weightOutDiffValues?.weightDiff > 0
                        ? styles.positive
                        : data?.weightOutDiffValues?.weightDiff === 0
                          ? styles.zero
                          : styles.negative
                    }`}
                  >
                    ({data?.weightOutDiffValues?.weightDiff > 0 ? '+' : ''}
                    {data?.weightOutDiffValues?.weightDiff?.toFixed(1)})
                  </div>
                ) : null}
              </div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.muscleMassKg')}</div>
                <p>{data?.weightOut?.muscleKilogram}</p>
                {data?.weightOutDiffValues?.muscleKilogramDiff && data?.weightOut?.weightedDate ? (
                  <div
                    className={`${styles['difference-label-alt']} ${
                      data?.weightOutDiffValues?.muscleKilogramDiff > 0
                        ? styles.positive
                        : data?.weightOutDiffValues?.muscleKilogramDiff === 0
                          ? styles.zero
                          : styles.negative
                    }`}
                  >
                    ({data?.weightOutDiffValues?.muscleKilogramDiff > 0 ? '+' : ''}
                    {data?.weightOutDiffValues?.muscleKilogramDiff?.toFixed(1)})
                  </div>
                ) : null}
              </div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.muscleMassPercentage')}</div>
                <p>{data?.weightOut?.musclePercentage}</p>
                {data?.weightOutDiffValues?.musclePercentageDiff && data?.weightOut?.weightedDate ? (
                  <div
                    className={`${styles['difference-label-alt']} ${
                      data?.weightOutDiffValues?.musclePercentageDiff > 0
                        ? styles.positive
                        : data?.weightOutDiffValues?.musclePercentageDiff === 0
                          ? styles.zero
                          : styles.negative
                    }`}
                  >
                    ({data?.weightOutDiffValues?.musclePercentageDiff > 0 ? '+' : ''}
                    {data?.weightOutDiffValues?.musclePercentageDiff?.toFixed(1)})
                  </div>
                ) : null}
              </div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.bodyFatPercentage')}</div>
                <p>{data?.weightOut?.bodyFat}</p>
                {data?.weightOutDiffValues?.bodyFatDiff && data?.weightOut?.weightedDate ? (
                  <div
                    className={`${styles['difference-label']} ${
                      data?.weightOutDiffValues?.bodyFatDiff > 0
                        ? styles.positive
                        : data?.weightOutDiffValues?.bodyFatDiff === 0
                          ? styles.zero
                          : styles.negative
                    }`}
                  >
                    ({data?.weightOutDiffValues?.bodyFatDiff > 0 ? '+' : ''}
                    {data?.weightOutDiffValues?.bodyFatDiff?.toFixed(1)})
                  </div>
                ) : null}
              </div>
              <div className={styles['acknowledge-container']}>
                <div className={styles['label-container']}>
                  <div className={styles['label-small']}>{t('admin.participant.acknowledgedBy')}</div>
                  <p className={styles['label-small-ans']}>{data?.weightOut?.acknowledgeByName ?? '-'}</p>
                </div>

                <div className={styles['label-container-ack']}>
                  <div className={styles['label-ack-small']}>{t('admin.participant.acknowledgedDate')}</div>
                  <p className={styles['label-ack-small-ans']}>
                    {data?.weightOut?.acknowledgeDateTime
                      ? dateTimeToCustomFormat(data?.weightOut.acknowledgeDateTime ?? '', 'DD/MM/yyyy')
                      : '-'}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className={styles['result-container-mobile']}>
            <div></div>
            <div className={styles['result-container-mobile-wrapper']}>
              <div className={styles['carousel-container']}>
                <ImageSlider
                  id="beforeImg"
                  slides={[
                    {
                      src: images.before_front.url ? images.before_front.url : PhotoUnavailable,
                      alt: 'Before Front View',
                    },
                    {
                      src: images.before_side.url ? images.before_side.url : PhotoUnavailable,
                      alt: 'Before Side View',
                    },
                  ]}
                  onClick={() => handleImageUpload('before')}
                />
              </div>
              <div className={styles['result-container-mobile-title']}>Before</div>
            </div>
            <div></div>
            <div className={styles['result-container-mobile-wrapper']}>
              <div className={styles['carousel-container']}>
                <ImageSlider
                  id="afterImg"
                  slides={[
                    {
                      src: images.after_front.url ? images.after_front.url : PhotoUnavailable,
                      alt: 'After Front View',
                    },
                    {
                      src: images.after_side.url ? images.after_side.url : PhotoUnavailable,
                      alt: 'After Side View',
                    },
                  ]}
                  onClick={() => handleImageUpload('after')}
                />
              </div>
              <div className={styles['result-container-mobile-title']}>After</div>
            </div>
          </div>
          <div className={styles['result-container-mobile']}>
            <div></div>
            <div className={styles['result-container-mobile-wrapper']}>
              <div className={styles['result-container-mobile-header-label']}>Pre-Assessment Date:</div>
              <div className={`${styles['tag-calendar']} ${styles['result-container-mobile-date']}`}>
                {data?.weightIn?.weightedDate ? (
                  <Tag
                    theme={Theme.GRAY}
                    text={dateTimeToCustomFormat(data?.weightIn?.weightedDate ?? '', 'DD/MM/yyyy')}
                    style={TagStyle.OUTLINE}
                  />
                ) : (
                  '-'
                )}
              </div>
            </div>
            <div className={styles['vertical-line-mobile']}></div>
            <div className={styles['result-container-mobile-wrapper']}>
              <div className={styles['result-container-mobile-header-label']}>Post-Assessment Date:</div>
              <div className={styles['tag-calendar']}>
                {data?.weightOut?.weightedDate ? (
                  <Tag
                    theme={Theme.GRAY}
                    text={dateTimeToCustomFormat(data?.weightOut?.weightedDate ?? '', 'DD/MM/yyyy')}
                    style={TagStyle.OUTLINE}
                  />
                ) : (
                  '-'
                )}
              </div>
            </div>
          </div>
          <div className={styles['result-container-mobile']}>
            <div>
              <div className={styles['result-container-mobile-label']}>Machine</div>
              <div className={styles['result-container-mobile-label']}>Height (cm)</div>
              <div className={styles['result-container-mobile-label']}>Weight (kg)</div>
              <div className={styles['result-container-mobile-label']}>Body Fat (%)</div>
              <div className={styles['result-container-mobile-label']}>Muscle Mass (kg)</div>
              <div className={styles['result-container-mobile-label']}>Muscle Mass (%)</div>

              {/* <div className={styles['result-container-mobile-label']}>Remark</div> */}
            </div>
            <div>
              <div className={styles['result-container-mobile-item']}>{data?.weightIn?.machine ?? '-'}</div>
              <div className={styles['result-container-mobile-item']}>{data?.weightIn?.height ?? '-'}</div>
              <div className={styles['result-container-mobile-item']}>{data?.weightIn?.weight ?? '-'}</div>
              <div className={styles['result-container-mobile-item']}>{data?.weightIn?.bodyFat ?? '-'}</div>
              <div className={styles['result-container-mobile-item']}>{data?.weightIn?.muscleKilogram ?? '-'}</div>
              <div className={styles['result-container-mobile-item']}>{data?.weightIn?.musclePercentage ?? '-'}</div>

              {/* <div className={styles['result-container-mobile-item']}>{data?.weightIn?.remarks ?? '-'}</div> */}
            </div>
            <div className={styles['vertical-line-mobile']}></div>
            <div>
              <div className={styles['result-container-mobile-item']}>{data?.weightOut?.machine ?? '-'}</div>
              <div className={styles['result-container-mobile-item']}>{data?.weightOut?.height ?? '-'}</div>
              <div className={styles['result-container-mobile-item']}>
                {data?.weightOut?.weight ?? '-'}
                {data?.weightOutDiffValues?.weightDiff && data?.weightOut?.weightedDate ? (
                  <span
                    className={`${styles['difference-label']} ${
                      data?.weightOutDiffValues?.weightDiff > 0
                        ? styles.positive
                        : data?.weightOutDiffValues?.weightDiff === 0
                          ? styles.zero
                          : styles.negative
                    }`}
                  >
                    ({data?.weightOutDiffValues?.weightDiff > 0 ? '+' : ''}
                    {data?.weightOutDiffValues?.weightDiff?.toFixed(1)})
                  </span>
                ) : null}
              </div>
              <div className={styles['result-container-mobile-item']}>
                {data?.weightOut?.bodyFat ?? '-'}
                {data?.weightOutDiffValues?.bodyFatDiff && data?.weightOut?.weightedDate ? (
                  <span
                    className={`${styles['difference-label']} ${
                      data?.weightOutDiffValues?.bodyFatDiff > 0
                        ? styles.positive
                        : data?.weightOutDiffValues?.bodyFatDiff === 0
                          ? styles.zero
                          : styles.negative
                    }`}
                  >
                    ({data?.weightOutDiffValues?.bodyFatDiff > 0 ? '+' : ''}
                    {data?.weightOutDiffValues?.bodyFatDiff?.toFixed(1)})
                  </span>
                ) : null}
              </div>
              <div className={styles['result-container-mobile-item']}>
                {data?.weightOut?.muscleKilogram ?? '-'}
                {data?.weightOutDiffValues?.muscleKilogramDiff && data?.weightOut?.weightedDate ? (
                  <span
                    className={`${styles['difference-label-alt']} ${
                      data?.weightOutDiffValues?.muscleKilogramDiff > 0
                        ? styles.positive
                        : data?.weightOutDiffValues?.muscleKilogramDiff === 0
                          ? styles.zero
                          : styles.negative
                    }`}
                  >
                    ({data?.weightOutDiffValues?.muscleKilogramDiff > 0 ? '+' : ''}
                    {data?.weightOutDiffValues?.muscleKilogramDiff?.toFixed(1)})
                  </span>
                ) : null}
              </div>
              <div className={styles['result-container-mobile-item']}>
                {data?.weightOut?.musclePercentage ?? '-'}
                {data?.weightOutDiffValues?.musclePercentageDiff && data?.weightOut?.weightedDate ? (
                  <span
                    className={`${styles['difference-label-alt']} ${
                      data?.weightOutDiffValues?.musclePercentageDiff > 0
                        ? styles.positive
                        : data?.weightOutDiffValues?.musclePercentageDiff === 0
                          ? styles.zero
                          : styles.negative
                    }`}
                  >
                    ({data?.weightOutDiffValues?.musclePercentageDiff > 0 ? '+' : ''}
                    {data?.weightOutDiffValues?.musclePercentageDiff?.toFixed(1)})
                  </span>
                ) : null}
              </div>

              {/* <div className={styles['result-container-mobile-item']}>{data?.weightOut?.remarks ?? '-'}</div> */}
            </div>
          </div>
          <div className={styles['acknowledge-container-mobile']}>
            <div className={styles['acknowledge-container-mobile-date']}>
              <div className={styles['result-container-mobile-label']}>Acknowledgement Date</div>
              <div className={styles['result-container-mobile-item']}>
                {data?.weightIn?.acknowledgeDateTime
                  ? formatDateDMYYYY(new Date(data?.weightIn?.acknowledgeDateTime))
                  : '-'}
              </div>
              <div className={styles['result-container-mobile-item']}>
                {data?.weightOut?.acknowledgeDateTime
                  ? formatDateDMYYYY(new Date(data?.weightOut?.acknowledgeDateTime))
                  : '-'}
              </div>
            </div>
            <div className={styles['acknowledge-container-mobile-by']}>
              <div className={styles['result-container-mobile-label']}>Acknowledge by</div>
              <div className={styles['result-container-mobile-item']}>{data?.weightIn?.acknowledgeBy ?? '-'}</div>
              <div className={styles['result-container-mobile-item']}>{data?.weightOut?.acknowledgeBy ?? '-'}</div>
            </div>
          </div>
        </>
      )}
      {data?.weightIn?.weightedDate && (
        <>
          <hr className={styles['progress-monitoring-line']} />
          {/* interim measurement  */}
          <div className={styles['progress-monitoring']}>
            <div className={styles['progress-monitoring-title-container']}>
              <div className={styles['progress-monitoring-title-container-title']}>Progress Monitoring</div>
              <div className={styles['progress-monitoring-title-container-subtitle']}>(Optional)</div>
              <Tooltip
                message={
                  'Progress monitoring is optional and intended solely for self-assessment. It does not affect the winning criteria.'
                }
                preference={TooltipPreference.RIGHT}
                className={styles['input-tool-tip']}
                iconName="circle-exclamation"
              />
            </div>
            <div>Track your health stats and observe your progress over time!</div>
            <div className={styles['progress-monitoring-log-container']}>
              <button
                onClick={() => setOpenProgressModal(true)}
                className={styles['progress-monitoring-button-section']}
              >
                <div className={styles['circle']}>
                  <div className={styles['plus']}></div>
                </div>
                <div className={styles['progress-monitoring-log-text']}>Add New Progress</div>
              </button>
            </div>
            {progressData?.length > 0 && (
              <TableWithAction
                actionColumnWidth={isDesktopView ? 20 : 5}
                enableCheckbox={false}
                dataSource={progressData ?? []}
                columns={progressMonitorConfig}
                pagination={true}
                rowKey={'recId'}
                menuItems={progressMenuItem}
                onActionColumnClickCb={actionColCb}
              />
            )}

            {addProgress}
            {deleteProgress}
          </div>
        </>
      )}

      {isOpen && (
        <Modal
          primaryButtonLabel={''}
          headline={''}
          closeIcon={false}
          containerWidth={'600px'}
          primaryButton={
            <Button
              title={t('admin.participant.save')}
              type={ButtonTypes.BUTTON}
              onClick={() => {
                handleFileUpload();
              }}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.SOLID}
              data-testid="test-add-button-popup"
            />
          }
          secondaryButton={
            <Button
              title={t('admin.participant.cancel')}
              type={ButtonTypes.BUTTON}
              onClick={handleCloseModal}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.OUTLINE}
              data-testid="test-cancel-button-popup-delete-modal"
            />
          }
        >
          <div className={styles['modal-upload']}>
            {carouselType === 'before' && (
              <div className={styles['before-container']}>
                <div className={styles['title']}>Before</div>
                <div className={styles['upload-container']}>
                  <div className={styles['image-container']}>
                    {images.before_front.url ? (
                      <div className={styles['image-wrapper']} style={{ position: 'relative' }}>
                        <img
                          src={images.before_front.url}
                          alt="Before Front View"
                          className={styles['uploaded-image']}
                        />
                        <div className={styles['buttons-container']}>
                          <button
                            className={styles['change-photo']}
                            onClick={() => document.getElementById('before_front')?.click()}
                          >
                            <img src={ChangeButton} alt="bg" />
                            <input
                              type="file"
                              id="before_front"
                              accept="image/*"
                              onChange={e => handleFile(e, 'before_front', true)}
                              style={{ display: 'none' }}
                            />
                          </button>
                          <button
                            className={styles['remove-photo']}
                            onClick={() => handleRemoveImage('before', 'front')}
                          >
                            <img src={RemoveButton} alt="bg" />
                          </button>
                        </div>
                      </div>
                    ) : (
                      <ImageEditor
                        onFileUpload={e => handleFileImage(e, 'front', true)}
                        accept="image/*"
                        imageEditorSize={ImageEditorSize.FIXED_SIZE}
                      />
                    )}
                    <div className={styles['label']}>Front View</div>
                  </div>
                  <div className={styles['image-container']}>
                    {images.before_side.url ? (
                      <div className={styles['image-wrapper']} style={{ position: 'relative' }}>
                        <img src={images.before_side.url} alt="Before Side View" className={styles['uploaded-image']} />
                        <div className={styles['buttons-container']}>
                          <button
                            className={styles['change-photo']}
                            onClick={() => document.getElementById('before_side')?.click()}
                          >
                            <img src={ChangeButton} alt="bg" />
                            <input
                              type="file"
                              id="before_side"
                              accept="image/*"
                              onChange={e => handleFile(e, 'before_side', true)}
                              style={{ display: 'none' }}
                            />
                          </button>
                          <button
                            className={styles['remove-photo']}
                            onClick={() => handleRemoveImage('before', 'side')}
                          >
                            <img src={RemoveButton} alt="bg" />
                          </button>
                        </div>
                      </div>
                    ) : (
                      <ImageEditor
                        onFileUpload={e => handleFileImage(e, 'side', true)}
                        accept="image/*"
                        imageEditorSize={ImageEditorSize.FIXED_SIZE}
                      />
                    )}
                    <div className={styles['label']}>Side View</div>
                  </div>
                </div>
              </div>
            )}
            {carouselType === 'after' && (
              <div className={styles['before-container']}>
                <div className={styles['title']}>After</div>
                <div className={styles['upload-container']}>
                  <div className={styles['image-container']}>
                    {images.after_front.url ? (
                      <div className={styles['image-wrapper']} style={{ position: 'relative' }}>
                        <img src={images.after_front.url} alt="After Front View" className={styles['uploaded-image']} />
                        <div className={styles['buttons-container']}>
                          <button
                            className={styles['change-photo']}
                            onClick={() => document.getElementById('after_front')?.click()}
                          >
                            <img src={ChangeButton} alt="bg" />
                            <input
                              type="file"
                              id="after_front"
                              accept="image/*"
                              onChange={e => handleFile(e, 'after_front', false)}
                              style={{ display: 'none' }}
                            />
                          </button>
                          <button
                            className={styles['remove-photo']}
                            onClick={() => handleRemoveImage('after', 'front')}
                          >
                            <img src={RemoveButton} alt="bg" />
                          </button>
                        </div>
                      </div>
                    ) : (
                      <ImageEditor
                        onFileUpload={e => handleFileImage(e, 'front', false)}
                        accept="image/*"
                        imageEditorSize={ImageEditorSize.FIXED_SIZE}
                      />
                    )}
                    <div className={styles['label']}>Front View</div>
                  </div>
                  <div className={styles['image-container']}>
                    {images.after_side.url ? (
                      <div className={styles['image-wrapper']} style={{ position: 'relative' }}>
                        <img src={images.after_side.url} alt="After Side View" className={styles['uploaded-image']} />
                        <div className={styles['buttons-container']}>
                          <button
                            className={styles['change-photo']}
                            onClick={() => document.getElementById('after_side')?.click()}
                          >
                            <img src={ChangeButton} alt="bg" />
                            <input
                              type="file"
                              id="after_side"
                              accept="image/*"
                              onChange={e => handleFile(e, 'after_side', false)}
                              style={{ display: 'none' }}
                            />
                          </button>
                          <button className={styles['remove-photo']} onClick={() => handleRemoveImage('after', 'side')}>
                            <img src={RemoveButton} alt="bg" />
                          </button>
                        </div>
                      </div>
                    ) : (
                      <ImageEditor
                        onFileUpload={e => handleFileImage(e, 'side', false)}
                        accept="image/*"
                        imageEditorSize={ImageEditorSize.FIXED_SIZE}
                      />
                    )}
                    <div className={styles['label']}>Side View</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Modal>
      )}
    </Card>
  );

  const rewardDetail = (
    <Card
      title={t('admin.dashboard.rewardStatus')}
      headerStyle={isDesktopView ? HeaderStyle.HEADER_5 : HeaderStyle.HEADER_6}
      containerHeight="100%"
    >
      <div className={styles['outer-reward-container']}>
        {data?.activities && data?.activities?.length > 0 ? (
          <div>
            {/* <div className={styles['details-info-reward-header']}>{data?.campaignName}</div> */}
            {rewardGiftModal}
          </div>
        ) : (
          <OperationCenterErrorCard
            errorType={ErrorType.NO_REWARD_AVAILABLE}
            className={styles['team-details-opt-card']}
          />
        )}
      </div>
    </Card>
  );

  const resultDetail = (
    <>
      {(isCoach || isLeader) && (
        <Card
          title={t('admin.dashboard.achievements')}
          headerStyle={isDesktopView ? HeaderStyle.HEADER_5 : HeaderStyle.HEADER_6}
        >
          <div className={`${styles['details-info-result']}`}>
            {/* {isLeader && (
              <>
                <div className={styles['details-info-result-total']}>
                  <div className={styles['details-info-result-total-title']}>{t('Qualified Coaches')}</div>
                  <div className={styles['details-info-result-total-number']}>{data?.totalQualified}</div>
                </div>
              </>
            )} */}
            {isCoach && data?.achievement && (
              <>
                {isLeader ? (
                  <>
                    <div className={`${styles['details-info-result-total-grid']}`}>
                      <div
                        className={`${styles['details-info-result-total-title']} ${styles['details-info-result-total-title-grid']}`}
                      ></div>
                      <div className={styles['details-info-result-total-header']}>As Coach</div>
                      <div className={styles['details-info-result-total-header']}>As Leader</div>
                    </div>
                    <div
                      className={`${styles['details-info-result-total']} ${styles['details-info-result-total-grid']}`}
                    >
                      <div
                        className={`${styles['details-info-result-total-title']} ${styles['details-info-result-total-title-grid']}`}
                      >
                        {t('Total Participants')}
                      </div>
                      <div className={styles['details-info-result-total-number']}>
                        {data?.achievement?.completed ?? 0}
                      </div>
                      <div className={styles['details-info-result-total-number']}>
                        {data?.summary?.completedCount ?? 0}
                      </div>
                    </div>
                    {/* <div
                      className={`${styles['details-info-result-total']} ${styles['details-info-result-total-grid']}`}>
                      <div
                        className={`${styles['details-info-result-total-title']} ${styles['details-info-result-total-title-grid']}`}>
                        {t('Subscribed to SOP')}
                      </div>
                      <div className={styles['details-info-result-total-number']}>{data?.achievement?.alp ?? 0}</div>
                      <div className={styles['details-info-result-total-number']}>{data?.summary?.alpCount ?? 0}</div>
                    </div> */}
                    <div
                      className={`${styles['details-info-result-total']} ${styles['details-info-result-total-grid']}`}
                    >
                      <div
                        className={`${styles['details-info-result-total-title']} ${styles['details-info-result-total-title-grid']}`}
                      >
                        {t('Achieved Winning Criteria')}
                      </div>
                      <div className={styles['details-info-result-total-number']}>
                        {data?.achievement?.achieved ?? 0}
                      </div>
                      <div className={styles['details-info-result-total-number']}>
                        {data?.summary?.achievedCount ?? 0}
                      </div>
                    </div>
                    <div
                      className={`${styles['details-info-result-total']} ${styles['details-info-result-total-grid']}`}
                    >
                      <div
                        className={`${styles['details-info-result-total-title']} ${styles['details-info-result-total-title-grid']}`}
                      >
                        {t('New Personal Sponsored ABO/APC')}
                      </div>
                      <div className={styles['details-info-result-total-number']}>
                        {data?.achievement?.sponsor ?? 0}
                      </div>
                      <div className={styles['details-info-result-total-number']}>
                        {data?.summary?.newAboCount ?? 0}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className={styles['details-info-result-total']}>
                      <div className={styles['details-info-result-total-title']}>{t('Total Participants')}</div>
                      <div className={styles['details-info-result-total-number']}>
                        {data?.achievement?.completed ?? 0}
                      </div>
                    </div>
                    {/* <div className={styles['details-info-result-total']}>
                      <div className={styles['details-info-result-total-title']}>
                        {t('Subscribed to SOP')}
                        <span className={styles['details-info-result-total-note-mobile']}>
                          Note: This does not contribute to the coach/leader winning criteria.
                        </span>
                      </div>
                      <div className={styles['details-info-result-total-number']}>{data?.achievement?.alp ?? 0}</div>
                      <span className={styles['details-info-result-total-note-desktop']}>
                        Note: This does not contribute to the coach/leader winning criteria.
                      </span>
                    </div> */}
                    <div className={styles['details-info-result-total']}>
                      <div className={styles['details-info-result-total-title']}>{t('Achieved Winning Criteria')}</div>
                      <div className={styles['details-info-result-total-number']}>
                        {data?.achievement?.achieved ?? 0}
                      </div>
                    </div>
                    <div className={styles['details-info-result-total']}>
                      <div className={styles['details-info-result-total-title']}>
                        {t('New Personal Sponsored ABO/APC')}
                      </div>
                      <div className={styles['details-info-result-total-number']}>
                        {data?.achievement?.sponsor ?? 0}
                      </div>
                    </div>
                  </>
                )}
              </>
            )}

            {isLeader && !isCoach && (
              <>
                <div className={styles['details-info-result-total']}>
                  <div className={styles['details-info-result-total-title']}>{t('Total Participants')}</div>
                  <div className={styles['details-info-result-total-number']}>{data?.summary?.completedCount ?? 0}</div>
                </div>

                {/* <div className={styles['details-info-result-total']}>
                  <div className={styles['details-info-result-total-title']}>
                    {t('Subscribed to SOP')}
                    <span className={styles['details-info-result-total-note-mobile']}>
                      Note: This does not contribute to the coach/leader winning criteria.
                    </span>
                  </div>
                  <div className={styles['details-info-result-total-number']}>{data?.summary?.alpCount ?? 0}</div>
                  <span className={styles['details-info-result-total-note-desktop']}>
                    Note: This does not contribute to the coach/leader winning criteria.
                  </span>
                </div> */}

                <div className={styles['details-info-result-total']}>
                  <div className={styles['details-info-result-total-title']}>{t('Achieved Winning Criteria')}</div>
                  <div className={styles['details-info-result-total-number']}>{data?.summary?.achievedCount ?? 0}</div>
                </div>
                <div className={styles['details-info-result-total']}>
                  <div className={styles['details-info-result-total-title']}>{t('New Personal Sponsored ABO/APC')}</div>
                  <div className={styles['details-info-result-total-number']}>{data?.summary?.newAboCount ?? 0}</div>
                </div>
              </>
            )}
          </div>
        </Card>
      )}
    </>
  );

  const fetchProfileImage = async (userId: number) => {
    try {
      const response = await AttachmentService.downloadProfileImage(userId ?? '');
      if (response.data && response.data.data && response.data.data.image) {
        setProfileImageUrls(prevState => ({
          ...prevState,
          [userId]: response.data.data.image,
        }));
      }
    } catch (error) {
      LoggerService.log('Error downloading image', error);
    }
  };

  useEffect(() => {
    data?.participantDetails?.forEach(participant => {
      fetchProfileImage(participant.userId);
    });
  }, [data?.participantDetails]);

  // const teamDetail = (
  //   <Card
  //     title={t('admin.dashboard.teamDetails')}
  //     headerStyle={isDesktopView ? HeaderStyle.HEADER_5 : HeaderStyle.HEADER_6}
  //   >
  //     {data?.participantDetails?.[0]?.userId ? (
  //       <div className={styles['team-details-container']}>
  //         <div className={styles['team-details-title-container']}>
  //           <div className={styles['team-details-title']}>Campaign: {data?.campaignName}</div>
  //           <div className={styles['team-details-coach']}>
  //             Coach :
  //             {data?.teamCoachName ? (
  //               <Tag
  //                 text={`${data?.teamCoachId} - ${data?.teamCoachName}`}
  //                 theme={Theme.WHITE}
  //                 style={TagStyle.OUTLINE}
  //               />
  //             ) : (
  //               <div>
  //                 <Button
  //                   title="Add Coach"
  //                   buttonStyle={ButtonStyles.OUTLINE}
  //                   size={isDesktopView ? ButtonSize.SMALL : ButtonSize.EXTRA_SMALL}
  //                   icon={{ iconName: 'square-plus', iconStyle: IconStyle.REGULAR }}
  //                   iconPosition={ButtonIconPosition.LEFT}
  //                   onClick={() => setShowCoachList(true)}
  //                 />
  //               </div>
  //             )}
  //           </div>
  //         </div>
  //         <div className={styles['team-details-subtitle-container']}>
  //           <div className={styles['team-details-subtitle']}>{data?.teamName}</div>
  //           <div className={styles['team-details-date-range']}>{`${
  //             data?.teamStartDate ? formatDateDMYYYY(new Date(data?.teamStartDate)) : 'N/A'
  //           } - ${data?.teamEndDate ? formatDateDMYYYY(new Date(data?.teamEndDate)) : 'N/A'}`}</div>
  //           <Tag
  //             text={data?.status ?? ''}
  //             theme={data?.status === 'ACTIVE' ? Theme.SUCCESS : Theme.PURPLE}
  //             style={TagStyle.OUTLINE}
  //           />
  //           {data?.coachEnrollmentDate ? (
  //             <div className={styles['team-details-total-points']}>Total Team Points: {data?.teamPoints}</div>
  //           ) : null}
  //         </div>
  //         <div>
  //           {data?.participantDetails
  //             ?.filter((participant) => participant.status === 'ACTIVE')
  //             .map((participant, i) => {
  //               return (
  //                 <div key={i} className={styles['team-details-progress-card']}>
  //                   <DetailCardProgress
  //                     coachEnrollmentDate={data?.coachEnrollmentDate}
  //                     profileImageUrl={profileImageUrls[participant.userId]}
  //                     {...participant}
  //                     handleRedirect={() => {
  //                       //navigate(`teams/${data?.teamId}/user?id=${participant.userId}`);
  //                       navigate(`myTeam/user?id=${participant.userId}&tId=${data?.teamId}`);
  //                     }}
  //                   />
  //                 </div>
  //               );
  //             })}
  //         </div>
  //       </div>
  //     ) : (
  //       <OperationCenterErrorCard errorType={ErrorType.NO_RECORD} className={styles['team-details-opt-card']} />
  //     )}
  //   </Card>
  // );

  const participantProgress = (
    <Card
      title={t('Individual Progress')}
      headerStyle={isDesktopView ? HeaderStyle.HEADER_5 : HeaderStyle.HEADER_6}
      containerHeight="100%"
    >
      <div className={styles['progress']}>
        <div className={styles['team-details-container']}>
          <div className={styles['team-details-title-container']}>
            <div className={styles['team-details-coach']}>
              <div className={styles['team-details-label']}>{'Campaign:'}</div>
              <div className={styles['team-details-date-range']}>{data?.campaignName}</div>
              {/* {data?.status && (
                <Tag
                  text={data?.status ?? ''}
                  theme={data?.status === 'ACTIVE' ? Theme.SUCCESS : Theme.PURPLE}
                  style={TagStyle.OUTLINE}
                />
              )}  */}
            </div>
            {isDesktopView && (
              <div className={styles['team-details-coach']}>
                {data?.teamCoachId && data?.teamCoachName ? (
                  <div
                    className={styles['team-details-date-range']}
                  >{`${data?.teamCoachId} - ${data?.teamCoachName}`}</div>
                ) : isIndividual ? (
                  <div>
                    <button className={styles['alp-button']} onClick={() => setShowCoachList(true)}>
                      <img className={styles['square-icon']} src={LayerSquarePlus} alt={'plus'} />
                      <p className={styles['invoice-text']}>{'Add Coach'}</p>
                    </button>
                    {/* <Button
                    title="Add Coach"
                    buttonStyle={isDesktopView ? ButtonStyles.OUTLINE : ButtonStyles.NONE}
                    size={isDesktopView ? ButtonSize.SMALL : ButtonSize.EXTRA_SMALL}
                    icon={{ iconName: 'square-plus', iconStyle: IconStyle.REGULAR }}
                    iconPosition={ButtonIconPosition.LEFT}
                    onClick={() => setShowCoachList(true)}
                  /> */}
                  </div>
                ) : (
                  '-'
                )}
              </div>
            )}
          </div>

          {!isDesktopView && (
            <div className={styles['team-details-coach']}>
              <div className={styles['team-details-label']}>{'Coach:'}</div>
              {data?.teamCoachId && data?.teamCoachName ? (
                <div
                  className={styles['team-details-date-range']}
                >{`${data?.teamCoachId} - ${data?.teamCoachName}`}</div>
              ) : isIndividual ? (
                <div>
                  <button className={styles['alp-button']} onClick={() => setShowCoachList(true)}>
                    <img className={styles['square-icon']} src={LayerSquarePlus} alt={'plus'} />
                    <p className={styles['invoice-text']}>{'Add Coach'}</p>
                  </button>
                  {/* <Button
                    title="Add Coach"
                    buttonStyle={isDesktopView ? ButtonStyles.OUTLINE : ButtonStyles.NONE}
                    size={isDesktopView ? ButtonSize.SMALL : ButtonSize.EXTRA_SMALL}
                    icon={{ iconName: 'square-plus', iconStyle: IconStyle.REGULAR }}
                    iconPosition={ButtonIconPosition.LEFT}
                    onClick={() => setShowCoachList(true)}
                  /> */}
                </div>
              ) : (
                '-'
              )}
            </div>
          )}

          <div className={styles['team-details-title-container']}>
            <div className={styles['team-details-coach']}>
              {!isIndividual && (
                <>
                  <div className={styles['team-details-label']}>{'Team:'}</div>
                  <div className={styles['team-details-date-range']}>{data?.teamName || 'N/A'}</div>
                </>
              )}
            </div>
            <div className={styles['team-details-coach']}>
              <div className={styles['team-details-date-range']}>
                {`${data?.teamStartDate ? formatDateDMYYYY(new Date(data.teamStartDate)) : 'N/A'} - ${
                  data?.teamEndDate ? formatDateDMYYYY(new Date(data.teamEndDate)) : 'N/A'
                }`}
              </div>
            </div>
          </div>

          <div>
            <div className={styles['team-details-progress-card']}>
              {data && (
                <DetailCardProgress
                  {...participantData}
                  profileImageUrl={profileImageUrls[decodedData.userId]}
                  showFiveProgress={false}
                  isCoachEnrollment={!isParticipant && participantData?.subscribe.length === 0}
                  purchase={participantData?.purchase || [{ orderName: '', orderNumber: '', orderStatus: 0 }]}
                  subscribe={participantData?.subscribe?.map((s: any) => s.orderNumber) || []}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );

  return (
    <div className={styles['dashboard-container']}>
      {/* {((formData?.weightIn?.weightedDate && !formData?.weightIn?.acknowledgeBy) ||
        (formData?.weightOut?.weightedDate && !formData?.weightOut?.acknowledgeBy)) && (
        <div className={`${styles['dashboard-container-acknowledgement']}`}>
          <div className={styles['details-card-wrapper']}>
            <div className={styles['details-container']}>
              <div className={`${styles['details-info']} ${styles['details-info-text']}`}>
                <img src={Error} alt={`beforeImg`} width={'32px'} height={'32px'} className={styles['warning']} />
                The Amway Brand Experience Team has updated your{' '}
                {formData?.weightIn?.weightedDate && !formData?.weightIn?.acknowledgeBy
                  ? 'Pre-Assessment'
                  : formData?.weightOut?.weightedDate && !formData?.weightOut?.acknowledgeBy
                    ? 'Post-Assessment'
                    : ''}{' '}
                Measurement. Please click "Confirm Details" to verify the updated information.
              </div>
              <div className={styles['confirm-button']}>
                <Button
                  title="Confirm Details"
                  type={ButtonTypes.BUTTON}
                  size={ButtonSize.SMALL}
                  buttonStyle={ButtonStyles.OUTLINE}
                  onClick={() => handleConfirmDetails()}
                />
              </div>
            </div>
          </div>
        </div>
      )} */}

      <div className={styles['dashboard-container-layout']}>
        <div className={styles['dashboard-container-layout-left']}>{userDetail}</div>
        {isParticipant && <div className={styles['participant-card']}>{participantProgress}</div>}
        {!isCoach && !isLeader && data?.activities && data?.activities?.length > 0 && (
          <div className={styles['dashboard-container-layout-reward']}>{rewardDetail}</div>
        )}
        <div className={styles['dashboard-container-layout-right']}>
          {isDesktopView ? (
            <>
              {isParticipant && (isCoach || isLeader) ? (
                <div className={styles['dashboard-container-layout-container']}>
                  <div className={styles['result-detail']}>{resultDetail}</div>
                  {data?.activities && data?.activities?.length > 0 && (
                    <div className={styles['reward-detail']}>{rewardDetail}</div>
                  )}
                </div>
              ) : null}
              {(isLeader && !isParticipant) || (isCoach && !isParticipant) ? (
                <div className={styles['dashboard-container-layout-container']}>
                  <div className={styles['result-detail']}>{resultDetail}</div>
                  {data?.activities && data?.activities?.length > 0 && (
                    <div className={styles['reward-detail']}>{rewardDetail}</div>
                  )}
                </div>
              ) : isParticipant ? (
                measurementDetail
              ) : null}
            </>
          ) : (
            <>
              {(isLeader || isCoach) && (
                <div className={styles['dashboard-container-layout-container']}>
                  <div className={styles['result-detail']}>{resultDetail}</div>
                  {data?.activities && data?.activities?.length > 0 && (
                    <div className={styles['reward-detail']}>{rewardDetail}</div>
                  )}
                </div>
              )}
              {isParticipant && measurementDetail}
            </>
          )}
        </div>
      </div>
      <div className={styles['dashboard-container-layout-bottom']}>
        {/* {isParticipant && !isCoach && !isLeader && <>{participantProgress}</>} */}
        {/* {isCoach && (
          <TeamList
            decodedData={decodedData}
            index={props.index}
            campaignData={props.campaignData}
            callFrom={'dashboard'}
          />
        )} */}
        {/* {isLeader && <Coach decodedData={decodedData} classes={styles['coach-section']} />} */}
      </div>
      {confirmationPrompt}
      {coachSelectionPrompt}
      {/* {acknowledgment} */}
    </div>
  );
};
